import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import { useNavigate, useParams } from "react-router-dom";
import { authUserData } from "../../utils/Helper";
import {
  Checkbox,
  Collapse,
  Form,
  Input,
  Spin,
  Table,
  Breadcrumb,
  Tooltip,
  Row,
  Col,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { useTranslation } from "react-i18next";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";

import { confirmAlert } from "react-confirm-alert";
import { InfoCircleOutlined } from "@ant-design/icons";

const VendorNewBisRFQCityWise = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();

  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [apiLoading, setapiLoading] = useState(false);
  const [data, setData] = useState([]);
  const [CategoryId, setCtaegoryTree] = useState();
  const vendorBidId = id ? atob(id) : null;

  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState([]);
  const [rfqnumber, setRFQNumber] = useState([]);
  const [rfqcurrency, setRFQCurrency] = useState([]);
  const [rfqfreight, setRFQFreight] = useState([]);
  const [rfqunloading, setRFQUnloading] = useState([]);
  const [rfqpricebasis, setRFQPriceBasis] = useState([]);
  const [rfqtransportInsurance, setRFQTransportInsurance] = useState([]);

  const [rfqopenorder, setRFQOpenOrder] = useState(false);
  const [rfqpricecap, setRFQPriceCap] = useState([]);
  const [trackingOfStages, setTrackingOfStages] = useState(0);

  const [currentStep, setCurrentStep] = useState(0);
  const [buyingPattern, setBuyingPattern] = useState("");

  const [showUnitRateOfCement, setShowUnitRateOfCement] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [hideR0, setHideR0] = useState(false);
  const [hideR1, setHideR1] = useState(false);
  const [summaryTableData, setSummaryTableData] = useState([]);
  const [summaryTableData2, setSummaryTableData2] = useState([]);

  const [summaryTableDataRevised, setSummaryTableDataRevised] = useState([]);
  const [summaryTableDataFinal, setSummaryTableDataFinal] = useState([]);

  const [resetMode, setResetMode] = useState(false);
  const [isFinalBid, setIsFinalBid] = useState(false);

  const [isFinalWhen, setIsFinalWhen] = useState({
    isFinalR: false,
    isFinalR1: false,
    isFinalR0: false,
  });

  const [averagePrices, setAveragePrices] = useState([]);
  const handleHideR0Change = (e) => {
    setHideR0(e.target.checked);
  };
  const handleHideR1Change = (e) => {
    setHideR1(e.target.checked);
  };
  const { Panel } = Collapse;
  const [amountsBySiteAndMaterial, setAmountsBySiteAndMaterial] = useState({});
  const [buyingPatternPayload, setBuyingPatternPayload] = useState(null);
  const [rfqDetails, setRfqDetails] = useState([]);
  const [winningRatio, setWinningRatio] = useState(null);
  const [lastFiveBid, setLastBid] = useState([]);
  const [winningArray, setWinningArray] = useState([]);

  const [initialBidDates, setInitialBidDates] = useState(null);
  const [revisedBidDates, setRevisedBidDates] = useState(null);
  const [finalBidDates, setFinalBidDates] = useState(null);
  const [tableSummary, setTableSummary] = useState(tableData);
  const [categoryTreeName, setCategoryTreeName] = useState("");
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [hideR, setHideR] = useState(false);
  const handleHideRChange = (e) => {
    setHideR(e.target.checked);
  };
  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [isFirstLoad]);

  const currentDate = (() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  })();
  const [state, setState] = useState([]);
  const [rfqData, setRfqData] = useState({
    open_order: false,
    rfqamountcap: "",
    rfqtimelinecap: "",
    rfqopendeliverydate: "",
    rfqdeliverystartdate: "",
    rfqdeliveryenddate: "",
    rfqduedate: "",
    rfqpricecap: "",
  });

  const [showUnitRateOfFreight, setShowUnitRateOfFreight] = useState(false);

  const calculateUnitRateWithGst = (
    initialBidPriceUnitRate,
    freightRate,
    gstRate,
    gst_rate_freight,
    fieldName
  ) => {
    let totalWithGst = 0;

    const sum = initialBidPriceUnitRate + (freightRate || 0);

    const gstAmount =
      initialBidPriceUnitRate + initialBidPriceUnitRate * (gstRate / 100);

    const gstAmountWithFreight =
      freightRate + freightRate * (gst_rate_freight / 100);

    totalWithGst = gstAmount + gstAmountWithFreight;

    return totalWithGst;
  };

  const calculateUnitRateWithGstRevised = (
    initialBidPriceUnitRate,
    freightRate,
    gstRate,
    gst_rate_freight,
    fieldName
  ) => {
    let totalWithGst = 0;

    const sum = initialBidPriceUnitRate + (freightRate || 0);

    const gstAmount =
      initialBidPriceUnitRate + initialBidPriceUnitRate * (gstRate / 100);

    const gstAmountWithFreight =
      freightRate + freightRate * (gst_rate_freight / 100);

    totalWithGst = gstAmount + gstAmountWithFreight;

    return totalWithGst;
  };

  const calculateUnitRateWithGstFinal = (
    initialBidPriceUnitRate,
    freightRate,
    gstRate,
    gst_rate_freight,
    fieldName
  ) => {
    let totalWithGst = 0;

    const sum = initialBidPriceUnitRate + (freightRate || 0);

    const gstAmount =
      initialBidPriceUnitRate + initialBidPriceUnitRate * (gstRate / 100);

    const gstAmountWithFreight =
      freightRate + freightRate * (gst_rate_freight / 100);

    totalWithGst = gstAmount + gstAmountWithFreight;

    return totalWithGst;
  };

  const handleInputChange = (e, siteId, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;
    const numericValue = parseFloat(value) || 0;

    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) return record;

        if (record.siteId === siteId && record.material_type === materialType) {
          const freightRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate_of_freight" ||
              fieldName === "revised_bid_price_unit_rate_of_freight" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate"
                ? record.initial_bid_price_unit_rate_of_freight
                : fieldName === "revised_bid_price_unit_rate"
                ? record.revised_bid_price_unit_rate_of_freight
                : fieldName === "final_bid_price_unit_rate"
                ? record.final_bid_price_unit_rate_of_freight
                : 0;
            }
          })();

          const unitRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate" ||
              fieldName === "revised_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate_of_freight"
                ? record.initial_bid_price_unit_rate
                : fieldName === "revised_bid_price_unit_rate_of_freight"
                ? record.revised_bid_price_unit_rate
                : fieldName === "final_bid_price_unit_rate_of_freight"
                ? record.final_bid_price_unit_rate
                : 0;
            }
          })();

          const updatedUnitRateWithGst =
            fieldName === "revised_bid_price_unit_rate" ||
            fieldName === "revised_bid_price_unit_rate_of_freight"
              ? calculateUnitRateWithGstRevised(
                  unitRate,
                  freightRate,
                  record.gst_rate,
                  record.gst_rate_freight,
                  fieldName
                )
              : fieldName === "final_bid_price_unit_rate" ||
                fieldName === "final_bid_price_unit_rate_of_freight"
              ? calculateUnitRateWithGstFinal(
                  unitRate,
                  freightRate,
                  record.gst_rate,
                  record.gst_rate_freight,
                  fieldName
                )
              : calculateUnitRateWithGst(
                  unitRate,
                  freightRate,
                  record.gst_rate,
                  record.gst_rate_freight,
                  fieldName
                );

          const updatedRecord = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst: updatedUnitRateWithGst,
          };

          const updatedRecordRevised = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst_revised: updatedUnitRateWithGst,
          };
          const updatedRecordFinal = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst_final: updatedUnitRateWithGst,
          };

          if (
            fieldName === "initial_bid_price_unit_rate" ||
            fieldName === "initial_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.initial_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "revised_bid_price_unit_rate" ||
            fieldName === "revised_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;

            updatedRecordRevised.revised_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "final_bid_price_unit_rate" ||
            fieldName === "final_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecordFinal.final_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          }

          return fieldName === "initial_bid_price_unit_rate" ||
            fieldName === "initial_bid_price_unit_rate_of_freight"
            ? updatedRecord
            : fieldName === "final_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ? updatedRecordFinal
            : updatedRecordRevised;
        }

        return record;
      });

      return updatedData;
    });

    setTableSummary((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) return record;

        if (record.siteId === siteId && record.material_type === materialType) {
          const freightRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate_of_freight" ||
              fieldName === "revised_bid_price_unit_rate_of_freight" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate"
                ? record.initial_bid_price_unit_rate_of_freight
                : fieldName === "revised_bid_price_unit_rate"
                ? record.revised_bid_price_unit_rate_of_freight
                : fieldName === "final_bid_price_unit_rate"
                ? record.final_bid_price_unit_rate_of_freight
                : 0;
            }
          })();

          const unitRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate" ||
              fieldName === "revised_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate_of_freight"
                ? record.initial_bid_price_unit_rate
                : fieldName === "revised_bid_price_unit_rate_of_freight"
                ? record.revised_bid_price_unit_rate
                : fieldName === "final_bid_price_unit_rate_of_freight"
                ? record.final_bid_price_unit_rate
                : 0;
            }
          })();

          const updatedUnitRateWithGst = calculateUnitRateWithGst(
            unitRate,
            freightRate,
            record.gst_rate,
            record.gst_rate_freight,
            fieldName
          );

          const updatedRecord = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst: updatedUnitRateWithGst,
          };

          if (
            fieldName === "initial_bid_price_unit_rate" ||
            fieldName === "initial_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.initial_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "revised_bid_price_unit_rate" ||
            fieldName === "revised_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.revised_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "final_bid_price_unit_rate" ||
            fieldName === "final_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.final_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          }

          return updatedRecord;
        }

        return record;
      });

      return updatedData;
    });

    if (
      fieldName === "initial_bid_price_unit_rate" ||
      fieldName === "initial_bid_price_unit_rate_of_freight"
    ) {
      const newTableData = [...tableSummary];

      const materialTotals = {};
      newTableData.forEach((cityDetail) => {
        const key =
          cityDetail.material_wise_uom !== "Cubic Meter" &&
          cityDetail.material_type_name;

        if (!key) return;

        if (!materialTotals[key]) {
          materialTotals[key] = {
            material_type_name: key,
            total_weighted_price: 0,
            total_quantity: 0,
          };
        }

        const quantity = cityDetail.material_total_quantity || 0;

        let rates = 0;

        if (
          fieldName === "initial_bid_price_unit_rate" ||
          fieldName === "initial_bid_price_unit_rate_of_freight"
        ) {
          rates = [
            cityDetail.initial_bid_price_unit_rate +
              cityDetail.initial_bid_price_unit_rate_of_freight || 0,
            (cityDetail.revised_bid_price_unit_rate = 0),
            (cityDetail.final_bid_price_unit_rate = 0),
          ].filter((rate) => rate > 0);
        }

        if (
          fieldName === "initial_bid_price_unit_rate_of_freight" ||
          fieldName === "initial_bid_price_unit_rate"
        ) {
          rates = [
            cityDetail.initial_bid_price_unit_rate +
              cityDetail.initial_bid_price_unit_rate_of_freight || 0,
            (cityDetail.revised_bid_price_unit_rate_of_freight = 0),
            (cityDetail.final_bid_price_unit_rate_of_freight = 0),
          ].filter((rate) => rate > 0);
        }

        const pricePerUnit =
          rates.length > 0 ? rates.reduce((a, b) => a + b) : 0;
        const weightedPrice = pricePerUnit * quantity;

        materialTotals[key].total_weighted_price += weightedPrice;
        materialTotals[key].total_quantity += quantity;
      });
    }
  };

  const calculateAverages = () => {
    const totals = {};

    tableData.forEach((record) => {
      if (!record.city_id || !record.siteId || !record.material_type_name)
        return;

      const uniqueKey = `${record.city_id}-${record.siteId}-${record.material_type_name}`;

      if (!totals[uniqueKey]) {
        totals[uniqueKey] = {
          city_id: record.city_id,
          siteId: record.siteId,
          material_type_name: record.material_type_name,
          total_price: 0,
          total_quantity: 0,
        };
      }

      const quantityInMT = record.material_total_quantity || 0;
      const price =
        record.initial_bid_price_unit_rate +
          record.initial_bid_price_unit_rate_of_freight || 0;

      totals[uniqueKey].total_price += price * quantityInMT;
      totals[uniqueKey].total_quantity += quantityInMT;
    });

    const averagePrices = Object.keys(totals).map((key) => {
      const {
        city_id,
        siteId,
        material_type_name,
        total_price,
        total_quantity,
      } = totals[key];
      const averagePriceMT = total_quantity ? total_price / total_quantity : 0;

      return {
        city_id,
        siteId,
        material_type_name,
        averagePriceMT,
      };
    });

    setAveragePrices(averagePrices);
  };

  useEffect(() => {
    calculateAverages();
  }, [tableData]);

  const handleUnitRateChange = (
    newUnitRate,
    siteId,
    materialType,
    cityId,
    isFreight = false
  ) => {
    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        return record;
      });

      const siteSubtotal = updatedData.reduce(
        (acc, record) => {
          const totalUnitRate =
            record.siteName !== "Sub-Total"
              ? record.initial_bid_price_unit_rate +
                record.initial_bid_price_unit_rate_of_freight
              : 0;

          const totalWithoutGST =
            record.siteName !== "Sub-Total"
              ? totalUnitRate * record.material_total_quantity
              : 0;

          const gstAmount =
            record.siteName !== "Sub-Total"
              ? (totalWithoutGST * (record?.gst_rate || 0)) / 100
              : 0;

          const newGSTAmount =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate +
              (record.initial_bid_price_unit_rate * (record?.gst_rate || 0)) /
                100;
          const newGSTAmountForFreight =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate_of_freight +
              (record.initial_bid_price_unit_rate_of_freight *
                (record?.gst_rate_freight || 0)) /
                100;

          if (record.siteId === siteId) {
            acc.total_initial_bid_price_unit_rate += totalWithoutGST;

            acc.total_revised_bid_price_unit_rate +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            acc.total_unit_rate_with_gst +=
              newGSTAmountForFreight + newGSTAmount || 0;

            acc.total_initial_bid_price_unit_rate_of_freight +=
              record.initial_bid_price_unit_rate_of_freight || 0;
          }
          return acc;
        },
        {
          total_initial_bid_price_unit_rate: 0,
          total_revised_bid_price_unit_rate: 0,
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst: 0,
          total_initial_bid_price_unit_rate_of_freight: 0,
          totalFreight: 0,
        }
      );
      const cityTotal = updatedData.reduce(
        (cityAcc, record) => {
          const totalUnitRate =
            record.siteName !== "City-Total"
              ? record.initial_bid_price_unit_rate +
                record.initial_bid_price_unit_rate_of_freight
              : 0;
          const totalWithoutGST =
            record.siteName !== "City-Total"
              ? totalUnitRate * record.material_total_quantity
              : 0;
          const gstAmount =
            record.siteName !== "City-Total"
              ? (totalWithoutGST * (record?.gst_rate || 0)) / 100
              : 0;

          const newGSTAmount =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate +
              (record.initial_bid_price_unit_rate * (record?.gst_rate || 0)) /
                100;
          const newGSTAmountForFreight =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate_of_freight +
              (record.initial_bid_price_unit_rate_of_freight *
                (record?.gst_rate_freight || 0)) /
                100;

          if (record.city_id === cityId) {
            cityAcc.total_initial_bid_price_unit_rate += totalWithoutGST;

            cityAcc.total_revised_bid_price_unit_rate +=
              record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight || 0;

            cityAcc.total_final_bid_price_unit_rate +=
              record.final_bid_price_unit_rate +
                record.final_bid_price_unit_rate_of_freight || 0;

            cityAcc.total_unit_rate_with_gst +=
              newGSTAmount + newGSTAmountForFreight || 0;
            cityAcc.totalFreight +=
              record.initial_bid_price_unit_rate_of_freight || 0;
          }
          return cityAcc;
        },
        {
          total_initial_bid_price_unit_rate: 0,
          total_revised_bid_price_unit_rate: 0,
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst: 0,
          totalFreight: 0,
        }
      );

      const finalData = updatedData.map((record) => {
        if (record.siteId === siteId) {
          return {
            ...record,
            total_initial_bid_price_unit_rate:
              siteSubtotal.total_initial_bid_price_unit_rate,
            total_initial_bid_price_unit_rate_of_freight:
              siteSubtotal.total_initial_bid_price_unit_rate_of_freight,
            total_revised_bid_price_unit_rate:
              siteSubtotal.total_revised_bid_price_unit_rate,
            total_final_bid_price_unit_rate:
              siteSubtotal.total_final_bid_price_unit_rate,
            total_unit_rate_with_gst: siteSubtotal.total_unit_rate_with_gst,
            totalFreight: siteSubtotal.totalFreight,
          };
        }
        if (record.siteName === "City-Total") {
          if (record.city_id === cityId) {
            return {
              ...record,
              total_initial_bid_price_unit_rate:
                cityTotal.total_initial_bid_price_unit_rate,
              total_initial_bid_price_unit_rate_of_freight:
                cityTotal.totalFreight,
              total_revised_bid_price_unit_rate:
                cityTotal.total_revised_bid_price_unit_rate,
              total_final_bid_price_unit_rate:
                cityTotal.total_final_bid_price_unit_rate,
              total_unit_rate_with_gst: cityTotal.total_unit_rate_with_gst,
              totalFreight: cityTotal.totalFreight,
            };
          }
        }
        return record;
      });

      return finalData;
    });
  };

  const handleUnitRateR1Change = (
    newUnitRate,
    siteId,
    materialType,
    cityId
  ) => {
    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        return record;
      });

      const siteSubtotal = updatedData.reduce(
        (acc, record) => {
          if (record.siteId === siteId) {
            acc.total_revised_bid_price_unit_rate +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            acc.total_unit_rate_with_gst_revised +=
              record.unit_rate_with_gst_revised || 0;

            acc.total_revised_bid_price_unit_rate_of_freight +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;
          }
          return acc;
        },
        {
          total_revised_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_revised: 0,
          total_revised_bid_price_unit_rate_of_freight: 0,
        }
      );

      const cityTotal = updatedData.reduce(
        (cityAcc, record) => {
          if (record.city_id === cityId) {
            cityAcc.total_revised_bid_price_unit_rate +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            cityAcc.total_unit_rate_with_gst_revised +=
              record.unit_rate_with_gst_revised !== undefined
                ? record.unit_rate_with_gst_revised
                : 0;

            cityAcc.total_revised_bid_price_unit_rate_of_freight +=
              record.revised_bid_price_unit_rate_of_freight *
              record.material_total_quantity;
          }
          return cityAcc;
        },
        {
          total_revised_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_revised: 0,
          total_revised_bid_price_unit_rate_of_freight: 0,
        }
      );

      const finalData = updatedData.map((record) => {
        if (record.siteId === siteId) {
          return {
            ...record,
            total_revised_bid_price_unit_rate:
              siteSubtotal.total_revised_bid_price_unit_rate,
            total_unit_rate_with_gst_revised:
              siteSubtotal.total_unit_rate_with_gst_revised,
            total_revised_bid_price_unit_rate_of_freight:
              siteSubtotal.total_revised_bid_price_unit_rate_of_freight,
          };
        }

        if (record.siteName === "City-Total") {
          if (record.city_id === cityId) {
            return {
              ...record,

              total_revised_bid_price_unit_rate:
                cityTotal.total_revised_bid_price_unit_rate,

              total_unit_rate_with_gst_revised:
                cityTotal.total_unit_rate_with_gst_revised,

              total_revised_bid_price_unit_rate_of_freight:
                cityTotal.total_revised_bid_price_unit_rate_of_freight,
            };
          }
        }
        return record;
      });

      return finalData;
    });
  };

  const handleUnitRateFinalChange = (
    newUnitRate,
    siteId,
    materialType,
    cityId
  ) => {
    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        return record;
      });

      const siteSubtotal = updatedData.reduce(
        (acc, record) => {
          if (record.siteId === siteId) {
            acc.total_final_bid_price_unit_rate +=
              (record.final_bid_price_unit_rate +
                record.final_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            acc.total_unit_rate_with_gst_final +=
              record.unit_rate_with_gst_final || 0;

            acc.total_final_bid_price_unit_rate_of_freight +=
              record.final_bid_price_unit_rate_of_freight || 0;
          }
          return acc;
        },
        {
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_final: 0,
          total_final_bid_price_unit_rate_of_freight: 0,
        }
      );

      const cityTotal = updatedData.reduce(
        (cityAcc, record) => {
          if (record.city_id === cityId) {
            cityAcc.total_final_bid_price_unit_rate +=
              (record.final_bid_price_unit_rate +
                record.final_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            cityAcc.total_unit_rate_with_gst_final +=
              record.unit_rate_with_gst_final !== undefined
                ? record.unit_rate_with_gst_final
                : 0;

            cityAcc.total_final_bid_price_unit_rate_of_freight +=
              record.revised_bid_price_unit_rate_of_freight *
              record.material_total_quantity;
          }
          return cityAcc;
        },
        {
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_final: 0,
          total_final_bid_price_unit_rate_of_freight: 0,
        }
      );

      const finalData = updatedData.map((record) => {
        if (record.siteId === siteId) {
          return {
            ...record,
            total_final_bid_price_unit_rate:
              siteSubtotal.total_final_bid_price_unit_rate,
            total_unit_rate_with_gst_final:
              siteSubtotal.total_unit_rate_with_gst_final,
            total_final_bid_price_unit_rate_of_freight:
              siteSubtotal.total_final_bid_price_unit_rate_of_freight,
          };
        }
        if (record.siteName === "City-Total") {
          if (record.city_id === cityId) {
            return {
              ...record,

              total_final_bid_price_unit_rate:
                cityTotal.total_final_bid_price_unit_rate,
              total_unit_rate_with_gst_final:
                cityTotal.total_unit_rate_with_gst_final,
              total_final_bid_price_unit_rate_of_freight:
                cityTotal.total_final_bid_price_unit_rate_of_freight, 
            };
          }
        }
        return record;
      });

      return finalData;
    });
  };

  const handleInputChangeDate = (e, siteId, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;
    setTableData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) => {
          if (site.site_id === siteId) {
            return {
              ...site,
              bid_rfq_material_details: site.bid_rfq_material_details.map(
                (material) => {
                  if (material.material_type === materialType) {
                    if (
                      [
                        "final_bid_price_unit_rate",
                        "revised_bid_price_unit_rate",
                        "initial_bid_price_date",
                      ].includes(fieldName)
                    ) {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                        unit_rate_with_gst: calculateUnitRateWithGst(
                          currentDate,
                          material.material_total_quantity,
                          material.gst_rate
                        ),
                      };
                      return updatedMaterial;
                    } else {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                      };
                      return updatedMaterial;
                    }
                  }
                  return material;
                }
              ),
            };
          }
          return site;
        }),
      }))
    );
  };

  const handleInputChangeFreight = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? {
                            ...material,
                            initial_bid_price_unit_rate_of_freight: value,
                          }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };

  const handleInputChangeUnitRateOfCementR1 = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? { ...material, revised_bid_price_unit_rate: value }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };
  const handleInputChangeUnitRateOfCementR = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? { ...material, final_bid_price_unit_rate: value }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };

  const handleInputChangeFreightR1 = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? {
                            ...material,
                            revised_bid_price_unit_rate_of_freight: value,
                          }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };
  const handleInputChangeFreightR = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? {
                            ...material,
                            final_bid_price_unit_rate_of_freight: value,
                          }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };
  const resetGSTValues = useCallback(() => {
    setTableData((prevData) =>
      prevData.map((item) => {
        if (item.material_type_name) {
          return {
            ...item,
          };
        }

        return item;
      })
    );
    setResetMode(true);
    setSummaryTableData((prevSummaryData) =>
      prevSummaryData?.map((city) => ({
        ...city,
        sites: city?.sites?.map((site) => ({
          ...site,
          totalAmountWithGst: 0,
          totalAmountWithoutGst: 0,
        })),
      }))
    );
  }, [setTableData, setResetMode]);

  const handleInputChangeUnitRateWIthGST = (e, siteId, materialType) => {
    const { value } = e.target;
    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_city_detail: city.bid_rfq_city_detail.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                material_details: site.material_details.map((material) =>
                  material.material_type === materialType
                    ? { ...material, unit_rate_with_gst: value }
                    : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeLQPForThisClient = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeAnyLqp = (e, siteId, materialType) => {
    const { value } = e.target;
    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_any_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };
  const handleDateChange = (cityIndex, siteIndex, field, value) => {
    const newData = [...tableData];
    newData[cityIndex].bid_rfq_site_details[siteIndex][field] = value;
    setTableData(newData);
  };

  useEffect(() => {
    const getVendorWinningRatio = async () => {
      try {
        const response = await getRequest(
          `bid-rfq/${rfqDetails.vendor_id}/bid-rfq-winning-ratio-of-one-year/?company_id=${rfqDetails.company_id}`
        );

        if (response?.data?.success === true) {
          setWinningRatio(response.data.data.winning_ratio);
          const arrayOfObjects = Object.entries(response.data.data).map(
            ([key, value]) => ({ key, value })
          );

          setWinningArray(arrayOfObjects);
        }
      } catch (error) {
        console.error("Error fetching vendor winning ratio:", error);
      }
    };

    if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
      getVendorWinningRatio();
    }
  }, [rfqDetails]);

  useEffect(() => {
    const getVendorFive = async () => {
      try {
        const response = await getRequest(
          `bid-rfq/${rfqDetails.vendor_id}/last-five-bid-results/?company_id=${rfqDetails.company_id}`
        );

        if (response?.data?.success === true) {
          let last = response?.data?.data;
          let lastReverse = last?.reverse();
          setLastBid(lastReverse);
        }
      } catch (error) {
        console.error("Error fetching vendor winning ratio:", error);
      }
    };

    if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
      getVendorFive();
    }
  }, [winningRatio]);

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiLoading(true);
      try {
        const response1 = await getRequest(
          `bid-rfq/${vendorBidId}/get-bid-rfq-city-wise/?vendor_id=${VendorId}`
        );
        const response = response1.data.data;

        let cityTotals = {};
        let serialNumber = 0;
        let lastCityName = null;
        let lastSiteName = null;

        const fattenData = response.bid_rfq_city_wise_detail.flatMap(
          (cityDetail, cityIndex) => {
            const siteMap = {};
            if (!cityTotals[cityDetail.city_id]) {
              cityTotals[cityDetail.city_id] = {
                total_initial_bid_price_unit_rate: 0,
                total_revised_bid_price_unit_rate: 0,
                total_initial_bid_price_unit_rate_of_freight: 0,
                total_revised_bid_price_unit_rate_of_freight: 0,
                total_material_total_quantity: 0,
                total_material_total_quantity_kg: 0,
                total_gst_rate: 0,
                total_unit_rate_with_gst: 0,
              };
            }

            const intermediateTotals = {};

            cityDetail.bid_rfq_site_details.forEach((siteDetail) => {
              const siteId = siteDetail.site_id;

              let siteSubtotal = 0;

              if (!siteMap[siteId]) {
                siteMap[siteId] = {
                  ...siteDetail,
                  bid_rfq_material_details: [],
                  showSiteName: true,
                  subtotal: {
                    initial_bid_price_unit_rate: 0,
                    initial_bid_price_unit_rate_of_freight: 0,
                    revised_bid_price_unit_rate: 0,
                    revised_bid_price_unit_rate_of_freight: 0,
                    material_total_quantity: 0,
                    material_total_quantity_by_kg: 0,
                    gst_rate: 0,
                    unit_rate_with_gst: 0,

                    unit_rate_with_gst_revised: 0,
                    unit_rate_with_gst_final: 0,

                    total_initial_bid_price_unit_rate: 0,
                    total_revised_bid_price_unit_rate: 0,
                  },
                };
              }

              let totalInitialBidPriceUnitRate = 0;

              siteDetail.bid_rfq_material_details.forEach((materialDetail) => {
                const materialType = materialDetail.material_type;
                const rfqVendorDetail = siteDetail.rfq_vendor_detail;

                const existingMaterial = siteMap[
                  siteId
                ].bid_rfq_material_details.find(
                  (material) => material.material_type === materialType
                );

                if (existingMaterial) {
                  existingMaterial.material_total_quantity +=
                    materialDetail.material_total_quantity || 0;
                  existingMaterial.material_total_quantity_by_kg +=
                    materialDetail.material_total_quantity_by_kg || 0;
                  existingMaterial.gst_rate += materialDetail.gst_rate || 0;
                  existingMaterial.initial_bid_price_unit_rate +=
                    materialDetail.initial_bid_price_unit_rate || 0;
                  existingMaterial.initial_bid_price_unit_rate_of_freight +=
                    materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                  existingMaterial.revised_bid_price_unit_rate +=
                    materialDetail.revised_bid_price_unit_rate || 0;
                  existingMaterial.revised_bid_price_unit_rate_of_freight +=
                    materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                  existingMaterial.unit_rate_with_gst +=
                    materialDetail.unit_rate_with_gst || 0;

                  existingMaterial.unit_rate_with_gst_revised +=
                    materialDetail.unit_rate_with_gst_revised || 0;

                  existingMaterial.rfq_vendor_detail = rfqVendorDetail;
                } else {
                  siteMap[siteId].bid_rfq_material_details.push({
                    ...materialDetail,
                    rfq_vendor_detail: rfqVendorDetail,
                  });
                }
                siteMap[siteId].subtotal.initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_price_unit_rate || 0;
                siteMap[
                  siteId
                ].subtotal.initial_bid_price_unit_rate_of_freight +=
                  materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                siteMap[siteId].subtotal.revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;
                siteMap[
                  siteId
                ].subtotal.revised_bid_price_unit_rate_of_freight +=
                  materialDetail.revised_bid_price_unit_rate_of_freight || 0;

                siteMap[siteId].subtotal.material_total_quantity +=
                  materialDetail.material_total_quantity || 0;
                siteMap[siteId].subtotal.material_total_quantity_by_kg +=
                  materialDetail.material_total_quantity_by_kg || 0;
                siteMap[siteId].subtotal.gst_rate +=
                  materialDetail.gst_rate || 0;
                siteMap[siteId].subtotal.unit_rate_with_gst +=
                  materialDetail.unit_rate_with_gst || 0;

                siteMap[siteId].subtotal.unit_rate_with_gst_revised +=
                  materialDetail.revised_unit_rate_with_gst || 0;

                siteMap[siteId].subtotal.total_initial_bid_price_unit_rate +=
                  (materialDetail.material_total_quantity || 0) *
                  (materialDetail.initial_bid_price_unit_rate +
                    materialDetail.initial_bid_price_unit_rate_of_freight || 0);

                siteMap[siteId].subtotal.total_revised_bid_price_unit_rate +=
                  (materialDetail.material_total_quantity || 0) *
                  (materialDetail.revised_bid_price_unit_rate +
                    materialDetail.revised_bid_price_unit_rate_of_freight || 0);

                cityTotals[
                  cityDetail.city_id
                ].total_initial_bid_price_unit_rate +=
                  materialDetail.initial_bid_price_unit_rate || 0;
                cityTotals[
                  cityDetail.city_id
                ].total_revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_initial_bid_price_unit_rate_of_freight +=
                  materialDetail.initial_bid_price_unit_rate_of_freight || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_revised_bid_price_unit_rate +=
                  materialDetail.revised_bid_price_unit_rate || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_revised_bid_price_unit_rate_of_freight +=
                  materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                cityTotals[cityDetail.city_id].total_material_total_quantity +=
                  materialDetail.material_total_quantity || 0;
                cityTotals[
                  cityDetail.city_id
                ].total_material_total_quantity_kg +=
                  materialDetail.material_total_quantity_by_kg || 0;
                cityTotals[cityDetail.city_id].total_gst_rate +=
                  materialDetail.gst_rate || 0;
                cityTotals[cityDetail.city_id].total_unit_rate_with_gst +=
                  materialDetail.unit_rate_with_gst || 0;

                cityTotals[
                  cityDetail.city_id
                ].total_unit_rate_with_gst_revised +=
                  materialDetail.unit_rate_with_gst_revised || 0;

                siteDetail.subtotal = siteSubtotal;

                const unitRate =
                  materialDetail.initial_bid_price_unit_rate || 0;
                const totalQtyKg =
                  materialDetail.material_total_quantity_by_kg || 0;

                const materialTotal = unitRate * totalQtyKg;

                siteSubtotal += materialTotal;

                intermediateTotals[siteId] =
                  (intermediateTotals[siteId] || 0) + materialTotal;

                totalInitialBidPriceUnitRate += materialTotal;
              });
            });

            let totalInitialBidPriceUnitRate = 0;

            const siteRows = Object.values(siteMap).flatMap(
              (site, siteIndex) => {
                const materialRows = site.bid_rfq_material_details.map(
                  (material) => {
                    const isCityChanged = lastCityName !== cityDetail.city_name;
                    const isSiteChanged = lastSiteName !== site.site_name;

                    const siteInitialBidPrice =
                      site.subtotal.material_total_quantity_by_kg *
                      site.subtotal.initial_bid_price_unit_rate;

                    totalInitialBidPriceUnitRate += siteInitialBidPrice;

                    if (isCityChanged) {
                      serialNumber++;
                      lastCityName = cityDetail.city_name;
                    }

                    if (isSiteChanged) {
                      lastSiteName = site.site_name;
                    }

                    const qtyKg = material.material_total_quantity_by_kg || 0;
                    const unitRate = material.initial_bid_price_unit_rate || 0;

                    const materialTotal =
                      (material.material_total_quantity_by_kg || 0) *
                      (material.initial_bid_price_unit_rate || 0);

                    intermediateTotals[site.site_id] =
                      (intermediateTotals[site.site_id] || 0) + materialTotal;

                    return {
                      sr_no: isCityChanged ? serialNumber : null,
                      city_id: cityDetail.city_name,
                      city_name: isCityChanged
                        ? cityDetail.city_name || null
                        : null,
                      site_name: isSiteChanged ? site.site_name || null : null,
                      siteId: site.site_id,
                      material_type_name: material.material_type_name || "",
                      material_type_sub_category:
                        material.material_type_sub_category,
                      material_wise_uom: material.material_wise_uom || "",
                      material_wise_uom_id: material.unit_of_measurement,
                      material_type: material.material_type || null,
                      material_total_quantity:
                        material.material_total_quantity || 0,
                      material_total_quantity_by_kg:
                        material.material_total_quantity_by_kg || 0,
                      gst_rate: material.gst_rate || 0,
                      gst_rate_freight: material.gst_rate_freight || 0,
                      initial_bid_price_unit_rate:
                        material.initial_bid_price_unit_rate || 0,

                      initial_bid_price_amount:
                        material.initial_bid_price_unit_rate *
                          material.material_total_quantity +
                          material.initial_bid_price_unit_rate_of_freight *
                            material.material_total_quantity || 0,

                      initial_bid_price_unit_rate_of_freight:
                        material.initial_bid_price_unit_rate_of_freight || 0,
                      revised_bid_price_unit_rate:
                        material.revised_bid_price_unit_rate || 0,

                      revised_bid_price_amount:
                        material.revised_bid_price_unit_rate *
                          material.material_total_quantity +
                          material.revised_bid_price_unit_rate_of_freight *
                            material.material_total_quantity || 0,

                      revised_bid_price_unit_rate_of_freight:
                        material.revised_bid_price_unit_rate_of_freight || 0,
                      final_bid_price_unit_rate:
                        material.final_bid_price_unit_rate,

                      final_bid_price_amount:
                        material.final_bid_price_unit_rate *
                          material.material_total_quantity +
                          material.final_bid_price_unit_rate_of_freight *
                            material.material_total_quantity || 0,

                      final_bid_price_unit_rate_of_freight:
                        material.final_bid_price_unit_rate_of_freight,
                      unit_rate_with_gst: material.unit_rate_with_gst || 0,
                      unit_rate_with_gst_revised:
                        material.revised_unit_rate_with_gst || 0,
                      rfq_vendor_detail: material.rfq_vendor_detail,
                      initial_bid_price_date: material.initial_bid_price_date,
                      revised_bid_price_date: material.revised_bid_price_date,
                      final_bid_price_date: material.final_bid_price_date,
                      rfq_material_detail: material.rfq_material_detail,
                      bid_rfq_id: material.bid_rfq_id || null,
                      is_initial_bid: material?.is_initial_bid,
                      is_revised_bid: material?.is_revised_bid,
                      is_final_bid: material?.is_final_bid,
                      aggregate_conversion: response.aggregate_conversion,
                      sand_conversion: response.sand_conversion,
                      category_tree_name: response.category_tree_name,
                    };
                  }
                );

                let materialTotal = 0;

                const qty = site.subtotal.material_total_quantity || 0;
                const qtyKg = site.subtotal.material_total_quantity_by_kg || 0;

                materialTotal += qty * qtyKg;

                intermediateTotals[site.site_id] =
                  (intermediateTotals[site.site_id] || 0) + materialTotal;

                materialRows.push({
                  key: `${cityIndex}-${siteIndex}-SubTotal`,
                  siteName: "Sub-Total",
                  siteId: site.site_id,
                  qty: site.subtotal.material_total_quantity,
                  qty_kg: site.subtotal.material_total_quantity_by_kg,

                  total_initial_bid_price_unit_rate:
                    site.subtotal.total_initial_bid_price_unit_rate || 0,

                  total_initial_bid_price_unit_rate_of_freight:
                    site.subtotal.initial_bid_price_unit_rate_of_freight,

                  total_revised_bid_price_unit_rate:
                    site.subtotal.total_revised_bid_price_unit_rate,

                  total_revised_bid_price_unit_rate_of_freight:
                    site.subtotal.revised_bid_price_unit_rate_of_freight,

                  total_unit_rate_with_gst: site.subtotal.unit_rate_with_gst,

                  total_unit_rate_with_gst_revised:
                    site.subtotal.unit_rate_with_gst_revised,

                  total_unit_rate_with_gst_final:
                    site.subtotal.unit_rate_with_gst_final,
                });

                return materialRows;
              }
            );

            const totalInitialBidPrice2 = siteRows.reduce(
              (acc, row) => acc + (row.total_initial_bid_price_unit_rate || 0),
              0
            );

            const cityId = [
              ...new Set(siteRows.map((row) => row.city_id)),
            ].join("");

            const totalQty = siteRows.reduce(
              (acc, row) => acc + (row.material_total_quantity || 0),
              0
            );
            const totalQtyInKg = siteRows.reduce(
              (acc, row) => acc + (row.material_total_quantity_by_kg || 0),
              0
            );

            // Calculate the subtotal for 'initial_bid_price_unit_rate'
            const totalInitialBidPrice = siteRows.reduce(
              (acc, row) => acc + (row.total_initial_bid_price_unit_rate || 0),
              0
            );

            const totalInitialBidFreightPrice = siteRows.reduce(
              (acc, row) =>
                acc + (row.total_initial_bid_price_unit_rate_of_freight || 0),
              0
            );

            const totalRevisedBidPrice = siteRows.reduce(
              (acc, row) => acc + (row.total_revised_bid_price_unit_rate || 0),
              0
            );
            const totalRevisedBidFreightPrice = siteRows.reduce(
              (acc, row) =>
                acc + (row.total_revised_bid_price_unit_rate_of_freight || 0),
              0
            );

            const totalInitialUnitRateGST = siteRows.reduce(
              (acc, row) => acc + (row.total_unit_rate_with_gst || 0),
              0
            );

            const totalRevisedUnitRateGST = siteRows.reduce(
              (acc, row) => acc + (row.total_unit_rate_with_gst_revised || 0),
              0
            );

            const totalFinalUnitRateGST = siteRows.reduce(
              (acc, row) => acc + (row.total_unit_rate_with_gst_final || 0),
              0
            );

            siteRows.push({
              key: `city-${cityIndex}-Total`,
              siteName: "City-Total",
              city_id: cityId,
              qty: totalQty,
              qty_kg: totalQtyInKg,

              total_initial_bid_price_unit_rate: totalInitialBidPrice,

              total_initial_bid_price_unit_rate_of_freight:
                totalInitialBidFreightPrice,

              total_revised_bid_price_unit_rate: totalRevisedBidPrice,

              total_revised_bid_price_unit_rate_of_freight:
                totalRevisedBidFreightPrice,
              total_unit_rate_with_gst: totalInitialUnitRateGST,
              // total_unit_rate_with_gst: "",

              total_unit_rate_with_gst_revised: totalRevisedUnitRateGST,

              total_unit_rate_with_gst_final: totalFinalUnitRateGST,
            });
            return siteRows;
          }
        );

        setTableData(fattenData);
        setCategoryTreeName(response1?.data?.data?.category_tree_name);
        const newFat = fattenData;

        setTableSummary(newFat);

        if (response?.bid_rfq_city_wise_detail) {
          let initialDates = null;
          let revisedDates = null;
          let finalDates = null;

          const firstCity = response.bid_rfq_city_wise_detail[0];
          if (firstCity) {
            const firstSite = firstCity.bid_rfq_site_details[0];
            if (firstSite) {
              const firstMaterial = firstSite.bid_rfq_material_details[0];
              if (firstMaterial) {
                initialDates = firstMaterial.initial_bid_price_date || null;
                revisedDates = firstMaterial.revised_bid_price_date || null;
                finalDates = firstMaterial.final_bid_price_date || null;
              }
            }
          }

          setInitialBidDates(initialDates);
          setRevisedBidDates(revisedDates);
          setFinalBidDates(finalDates);
        }

        setCompanyName(response.company);
        if (
          response.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
            .bid_rfq_material_details[0].initial_bid_price_date !== null
        ) {
          setHideR1(false);
          setCurrentStep(1);
          resetGSTValues();
        }
        if (
          response.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
            .bid_rfq_material_details[0].revised_bid_price_date !== null
        ) {
          setHideR1(false);
          setCurrentStep(2);
          resetGSTValues();
        }
        setRfqDetails(response);
        setRFQNumber(response.rfq_number);
        setRFQCurrency(response.currency_name);
        setRFQPriceBasis(response.price_basis);
        setRFQFreight(response.freight);
        setRFQUnloading(response.unloading);
        setRFQTransportInsurance(response.transport_insurance);
        setRFQOpenOrder(response.open_order);
        setRFQPriceCap(response.price_cap);
        setRfqData({
          open_order: response.open_order,
          rfqamountcap: response.amount_cap,
          rfqtimelinecap: response.timeline_cap,
          rfqopendeliverydate: response.delivery_date,
          rfqdeliverystartdate: response.delivery_start_date,
          rfqdeliveryenddate: response.delivery_end_date,
          rfqduedate: response.rfq_due_date,
          rfqpricecap: response.price_cap,
        });
        setState((prevState) => {
          return {
            ...prevState,
            bid_rfq_city_wise_detail: response.bid_rfq_city_wise_detail,
          };
        });
        const buying_pattern = response.buying_pattern;
        setBuyingPatternPayload(buying_pattern);
        setBuyingPattern(buying_pattern);
        if (buying_pattern === "Unit Rate of Cement excluding Freight") {
          setShowUnitRateOfCement(true);
          setShowUnitRateOfFreight(true);
        } else if (buying_pattern === "Unit Rate of Cement including Freight") {
          setShowUnitRateOfCement(true);
          setShowUnitRateOfFreight(false);
        } else if (buying_pattern === "Total Unit Rate") {
          setShowUnitRateOfCement(false);
          setShowUnitRateOfFreight(true);
        }
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      } finally {
        setapiLoading(false);
      }
    };
    getVendorBidRFQ();
  }, [vendorBidId]);

  const hideR1Columns = hideR1 ? [] : {};

  const calculateSubtotals = (tableData) => {
    let siteSubtotals = {};
    let grandTotalCement = 0;
    let grandTotalFreight = 0;

    tableData.forEach((record) => {
      if (!record.isSubtotal) {
        const siteId = record.siteId;
        if (!siteSubtotals[siteId]) {
          siteSubtotals[siteId] = {
            totalCement: 0,
            totalFreight: 0,
          };
        }

        siteSubtotals[siteId].totalCement += Number(
          record.initial_bid_price_unit_rate || 0
        );
        siteSubtotals[siteId].totalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
        grandTotalCement += Number(record.initial_bid_price_unit_rate || 0);
        grandTotalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
      }
    });

    return { grandTotalCement, grandTotalFreight, siteSubtotals };
  };

  const { grandTotalCement, grandTotalFreight, siteSubtotals } =
    calculateSubtotals(tableData);

  const getColumns = () => {
    const columns = [
      {
        title: "Sr.",
        dataIndex: "sr_no",
        key: "sr_no",
        width: 50,
        fixed: "left",
      },
      {
        title: "City",
        dataIndex: "city_name",
        key: "city_name",
        width: 120,
        fixed: "left",
      },
      {
        title: "Site",
        dataIndex: "site_name",
        key: "site_name",
        width: 120,
        fixed: "left",
        render: (text, record) => {
          if (record?.site_name) {
            return <div className="normal-field">{record.site_name}</div>;
          } else if (record?.siteName === "Sub-Total") {
            return (
              <div className="subtotal1" style={{ textAlign: "center" }}>
                {"Sub Total"}
              </div>
            );
          } else if (record?.siteName === "City-Total") {
            return (
              <div className="citytotal2" style={{ textAlign: "center" }}>
                {"City Total"}
              </div>
            );
          } else {
            return null;
          }
        },
      },
      {
        title: "Sub category",
        dataIndex: "material_type_sub_category",
        key: "material_type_sub_category",
        width: 140,
        fixed: "left",
      },
      {
        title: "Material Type",
        dataIndex: "material_type_name",
        key: "material_type_name",
        width: 130,
        fixed: "left",
      },

      {
        title: "Qty.",
        dataIndex: "material_total_quantity",
        key: "material_total_quantity",
        align: "right",
        width: 60,
        fixed: "left",
        render: (text, record) => {
          if (record?.material_total_quantity) {
            return (
              <div style={{ marginRight: "10px" }}>
                {record.material_total_quantity.toFixed(2)}
              </div>
            );
          } else if (record.siteName === "Sub-Total" && record?.qty) {
            return null;
          } else if (record.siteName === "City-Total" && record?.qty) {
            return null;
          } else {
            return null;
          }
        },
      },

      {
        title: "UoM.",
        dataIndex: "material_wise_uom",
        key: "material_wise_uom",
        width: 100,
        fixed: "left",
        render: (text, record) => {
          if (text === "Cubic Meter") {
            return "Cu. Mtr.";
          } else {
            return text;
          }
        },
      },
    ].filter(Boolean);

    if (revisedBidDates) {
      columns.push(
        currentStep >= 2 && {
          title: (
            <>
              <Tooltip color="#094E8F" placement="top" title={"R - Final BID"}>
                <span>R (Without GST)</span>
              </Tooltip>
            </>
          ),
          children:
            currentStep >= 2
              ? [
                  showUnitRateOfCement && {
                    title: "Unit Rate",
                    dataIndex: "final_bid_price_unit_rate",
                    key: "final_bid_price_unit_rate",
                    width: "120px",

                    render: (text, record) => {
                      const isSubtotal = record.isSubtotal;
                      let grandTotal = 0;
                      grandTotal += record.final_bid_price_unit_rate;

                      const allRecords = tableData;
                      const sameMaterialTypeRecords = allRecords.filter(
                        (item) => item.material_type === record.material_type
                      );

                      const isValueConsistent = sameMaterialTypeRecords.every(
                        (item) =>
                          item.final_bid_price_unit_rate ===
                          record.final_bid_price_unit_rate
                      );
                      const isFirstEntry = (record) => {
                        const sameMaterialTypeRecords = tableData.filter(
                          (item) => item.material_type === record.material_type
                        );
                        return sameMaterialTypeRecords.indexOf(record) === 0;
                      };

                      return (
                        <div>
                          {record?.siteName === "Sub-Total" ? (
                            <div style={{ marginLeft: "1px" }}> </div>
                          ) : record?.siteName === "City-Total" ? (
                            <div style={{ marginLeft: "1px" }}> </div>
                          ) : (
                            <>
                              <Input
                                name={`final_bid_price_unit_rate_${record.material_type}`}
                                value={record.final_bid_price_unit_rate ?? ""}
                                prefix={<RupeesSign />}
                                maxLength={5}
                                onChange={(e) => {
                                  handleInputChange(
                                    e,
                                    record.siteId,
                                    record.material_type,
                                    "final_bid_price_unit_rate"
                                  );
                                  handleUnitRateFinalChange(
                                    e.target.value,
                                    record.siteId,
                                    record.material_type,
                                    record.city_id
                                  );
                                }}
                                style={{
                                  width: "80px",
                                  borderColor: !isValueConsistent
                                    ? "#a9e7ff"
                                    : "",
                                  borderWidth: !isValueConsistent ? "2px" : "",
                                }}
                              />
                              {!isValueConsistent && !isFirstEntry(record) && (
                                <Tooltip title="The unit rate is different for the same material">
                                  <InfoCircleOutlined
                                    style={{
                                      color: "#094E8F",
                                      marginLeft: "5px",
                                    }}
                                  />
                                </Tooltip>
                              )}
                            </>
                          )}
                        </div>
                      );
                    },
                  },
                  showUnitRateOfFreight && {
                    title: "Unit Rate Freight",
                    dataIndex: "final_bid_price_unit_rate_of_freight",
                    key: "final_bid_price_unit_rate_of_freight",
                    width: "100px",
                    align: "right",
                    render: (text, record) => {
                      const isSubtotal = record.isSubtotal;
                      let grandTotal = 0;
                      grandTotal += record.final_bid_price_unit_rate_of_freight;

                      const allRecords = tableData;
                      const sameMaterialTypeRecords = allRecords.filter(
                        (item) => item.material_type === record.material_type
                      );

                      const isValueConsistent = sameMaterialTypeRecords.every(
                        (item) =>
                          item.final_bid_price_unit_rate_of_freight ===
                          record.final_bid_price_unit_rate_of_freight
                      );
                      const isFirstEntry = (record) => {
                        const sameMaterialTypeRecords = tableData.filter(
                          (item) => item.material_type === record.material_type
                        );
                        return sameMaterialTypeRecords.indexOf(record) === 0;
                      };

                      return (
                        <div>
                          {record?.siteName === "Sub-Total" ? (
                            <div style={{ marginLeft: "1px" }}></div>
                          ) : record?.siteName === "City-Total" ? (
                            <div style={{ marginLeft: "1px" }}></div>
                          ) : currentStep !== 2 &&
                            record?.siteName !== "Sub-Total" ? (
                            <div style={{ marginLeft: "1px" }}>
                              ₹{" "}
                              {record.final_bid_price_unit_rate_of_freight ??
                                ""}
                            </div>
                          ) : (
                            <>
                              <Input
                                name={`final_bid_price_unit_rate_of_freight_${record.material_type}`}
                                value={
                                  record.final_bid_price_unit_rate_of_freight ??
                                  ""
                                }
                                prefix={<RupeesSign />}
                                maxLength={5}
                                onChange={(e) => {
                                  handleInputChange(
                                    e,
                                    record.siteId,
                                    record.material_type,
                                    "final_bid_price_unit_rate_of_freight"
                                  );
                                  handleUnitRateFinalChange(
                                    e.target.value,
                                    record.siteId,
                                    record.material_type,
                                    record.city_id
                                  );
                                }}
                                style={{
                                  width: "80px",
                                }}
                              />
                            </>
                          )}
                        </div>
                      );
                    },
                  },
                  showUnitRateOfCement && {
                    title: "Amount",
                    dataIndex: "final_bid_price_amount",
                    key: "final_bid_price_amount",
                    width: "130px",
                    align: "right",
                    render: (text, record) => {
                      const isSubtotal = record.isSubtotal;

                      const allRecords = tableData;

                      const sameMaterialTypeRecords = allRecords.filter(
                        (item) => item.material_type === record.material_type
                      );

                      const isValueConsistent = sameMaterialTypeRecords.every(
                        (item) =>
                          item.initial_bid_price_unit_rate ===
                          record.initial_bid_price_unit_rate
                      );
                      const isFirstEntry = (record) => {
                        const sameMaterialTypeRecords = tableData.filter(
                          (item) => item.material_type === record.material_type
                        );
                        return sameMaterialTypeRecords.indexOf(record) === 0;
                      };

                      return record?.siteName === "Sub-Total" ? (
                        <div
                          className="subtotal1"
                          style={{ marginLeft: "1px" }}
                        >
                          ₹{" "}
                          {record.total_final_bid_price_unit_rate?.toLocaleString(
                            "en-IN"
                          ) ?? "0"}
                        </div>
                      ) : record?.siteName === "City-Total" ? (
                        <div
                          className="citytotal2"
                          style={{ marginLeft: "1px" }}
                        >
                          ₹{" "}
                          {record.total_final_bid_price_unit_rate?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          ) ?? "0"}
                        </div>
                      ) : currentStep !== 0 &&
                        record?.siteName !== "Sub-Total" ? (
                        <div
                          className="normal-field"
                          style={{ marginLeft: "1px" }}
                        >
                          ₹ {record.final_bid_price_amount ?? ""}
                        </div>
                      ) : (
                        <div
                          className="normal-field"
                          style={{ marginLeft: "1px" }}
                        >
                          ₹ {record.final_bid_price_amount ?? ""}
                        </div>
                      );
                    },
                  },
                  showUnitRateOfCement && {
                    title: "Unit Rate With GST",
                    dataIndex: "unit_rate_with_gst_final",
                    key: "unit_rate_with_gst_final",
                    width: "130px",
                    align: "right",
                    render: (text, record) => {
                      const isSubtotal = record.isSubtotal;
                      let grandTotal = 0;
                      if (!isSubtotal) {
                        grandTotal = tableData
                          .filter(
                            (row) =>
                              row.siteId === record.siteId && !row.isSubtotal
                          )
                          .reduce(
                            (acc, curr) =>
                              acc +
                              (parseFloat(curr.unit_rate_with_gst_revised) ||
                                0),
                            0
                          );
                      }
                      return (
                        <>
                          {record?.siteName === "City-Total" ? (
                            ""
                          ) : record?.siteName !== "Sub-Total" ? (
                            <div
                              className="normal-field"
                              style={{ marginLeft: "1px" }}
                            >
                              {" "}
                              ₹{" "}
                              {record.unit_rate_with_gst_final?.toFixed(2) ?? 0}
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    },
                  },
                ].filter(Boolean)
              : [].filter(Boolean),
        },
        !hideR1 &&
          currentStep >= 1 && {
            title: (
              <>
                <Tooltip
                  color="#094E8F"
                  placement="top"
                  title={"R1 - Revised BID"}
                >
                  <span>R1 (Without GST)</span>{" "}
                  {revisedBidDates ? `(${revisedBidDates})` : ""}
                </Tooltip>
              </>
            ),
            children: [
              showUnitRateOfCement && {
                title: "Unit Rate",
                dataIndex: "revised_bid_price_unit_rate",
                key: "revised_bid_price_unit_rate",
                width: "95px",
                align: "right",
                render: (text, record) => {
                  return (
                    <div>
                      {record?.siteName === "Sub-Total" ? (
                        <div style={{ marginLeft: "1px" }}> </div>
                      ) : record?.siteName === "City-Total" ? (
                        <div style={{ marginLeft: "1px" }}> </div>
                      ) : currentStep !== 1 &&
                        record?.siteName !== "Sub-Total" ? (
                        <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                          {revisedBidDates &&
                          record.revised_bid_price_unit_rate === 0
                            ? "Not Quoted"
                            : `₹ ${record.revised_bid_price_unit_rate}` ?? ""}
                        </div>
                      ) : (
                        <>
                          <Input
                            name={`revised_bid_price_unit_rate_${record.material_type}`}
                            value={record.revised_bid_price_unit_rate ?? ""}
                            prefix={<RupeesSign />}
                            maxLength={5}
                            onChange={(e) => {
                              handleInputChange(
                                e,
                                record.siteId,
                                record.material_type,
                                "revised_bid_price_unit_rate"
                              );
                              handleUnitRateR1Change(
                                e.target.value,
                                record.siteId,
                                record.material_type,
                                record.city_id
                              );
                            }}
                            disabled={currentStep !== 1}
                            required
                            style={{
                              width: "80px",
                            }}
                          />
                        </>
                      )}
                    </div>
                  );
                },
              },
              showUnitRateOfFreight && {
                title: "Unit Rate Freight",
                dataIndex: "revised_bid_price_unit_rate_of_freight",
                key: "revised_bid_price_unit_rate_of_freight",
                width: "100px",
                align: "right",
                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;
                  let grandTotal = 0;
                  grandTotal += record.revised_bid_price_unit_rate_of_freight;

                  const allRecords = tableData;
                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.revised_bid_price_unit_rate_of_freight ===
                      record.revised_bid_price_unit_rate_of_freight
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return (
                    <div>
                      {record?.siteName === "Sub-Total" ? (
                        <div style={{ marginLeft: "1px" }}></div>
                      ) : record?.siteName === "City-Total" ? (
                        <div style={{ marginLeft: "1px" }}></div>
                      ) : currentStep !== 1 &&
                        record?.siteName !== "Sub-Total" ? (
                        <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                          {/* ₹{" "} */}
                          {revisedBidDates &&
                          record.revised_bid_price_unit_rate_of_freight === 0
                            ? "Not Quoted"
                            : `₹ ${record.revised_bid_price_unit_rate_of_freight?.toLocaleString(
                                "en-IN"
                              )}` ?? ""}
                        </div>
                      ) : (
                        <>
                          <Input
                            name={`revised_bid_price_unit_rate_of_freight_${record.material_type}`}
                            value={
                              record.revised_bid_price_unit_rate_of_freight ??
                              ""
                            }
                            prefix={<RupeesSign />}
                            onChange={(e) => {
                              handleInputChange(
                                e,
                                record.siteId,
                                record.material_type,
                                "revised_bid_price_unit_rate_of_freight"
                              );
                              handleUnitRateR1Change(
                                e.target.value,
                                record.siteId,
                                record.material_type,
                                record.city_id
                              );
                            }}
                            disabled={currentStep !== 1}
                            style={{
                              width: "80px",
                            }}
                          />
                        </>
                      )}
                    </div>
                  );
                },
              },

              showUnitRateOfCement && {
                title: "Amount",
                dataIndex: "revised_bid_price_amount",
                key: "revised_bid_price_amount",
                width: "130px",
                align: "right",
                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;

                  const allRecords = tableData;

                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.initial_bid_price_unit_rate ===
                      record.initial_bid_price_unit_rate
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return record?.siteName === "Sub-Total" ? (
                    <div className="subtotal1" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.total_revised_bid_price_unit_rate?.toLocaleString(
                        "en-IN"
                      ) ?? "0"}
                    </div>
                  ) : record?.siteName === "City-Total" ? (
                    <div className="citytotal2" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.total_revised_bid_price_unit_rate?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 0 }
                      ) ?? "0"}
                    </div>
                  ) : currentStep !== 0 && record?.siteName !== "Sub-Total" ? (
                    <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                      {/* ₹{" "} */}
                      {revisedBidDates && record.revised_bid_price_amount === 0
                        ? "Not Quoted"
                        : `₹ ${record.revised_bid_price_amount?.toLocaleString(
                            "en-IN"
                          )}` ?? ""}
                    </div>
                  ) : (
                    <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                      ₹{" "}
                      {record.revised_bid_price_amount?.toLocaleString(
                        "en-IN"
                      ) ?? ""}
                    </div>
                  );
                },
              },
              showUnitRateOfCement && {
                title: "Unit Rate With GST",
                dataIndex: "unit_rate_with_gst_revised",
                key: "unit_rate_with_gst_revised",
                width: "130px",
                align: "right",
                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;
                  let grandTotal = 0;
                  if (!isSubtotal) {
                    grandTotal = tableData
                      .filter(
                        (row) => row.siteId === record.siteId && !row.isSubtotal
                      )
                      .reduce(
                        (acc, curr) =>
                          acc +
                          (parseFloat(curr.unit_rate_with_gst_revised) || 0),
                        0
                      );
                  }
                  return (
                    <>
                      {record?.siteName === "City-Total" ? (
                        ""
                      ) : record?.siteName !== "Sub-Total" ? (
                        <div
                          className="normal-field"
                          style={{ marginLeft: "1px" }}
                        >
                          {" "}
                          {revisedBidDates &&
                          record.unit_rate_with_gst_revised === 0
                            ? "Not Quoted"
                            : `₹ ${
                                record.unit_rate_with_gst_revised?.toFixed(2) ??
                                0
                              }`}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  );
                },
              },
            ].filter(Boolean),
          },
        !hideR0 && {
          title: (
            <>
              <Tooltip
                color="#094E8F"
                placement="top"
                title={"R0 - Initial BID"}
              >
                <span>R0 (Without GST)</span>{" "}
                {!hideR1 && currentStep >= 1 ? `(${initialBidDates})` : ""}
              </Tooltip>
            </>
          ),
          children: [
            showUnitRateOfCement && {
              title: "Unit Rate",
              dataIndex: "initial_bid_price_unit_rate",
              key: "initial_bid_price_unit_rate",
              width: "95px",
              align: "right",
              render: (text, record) => {
                const isSubtotal = record.isSubtotal;
                const allRecords = tableData;

                const sameMaterialTypeRecords = allRecords.filter(
                  (item) => item.material_type === record.material_type
                );

                const isValueConsistent = sameMaterialTypeRecords.every(
                  (item) =>
                    item.initial_bid_price_unit_rate ===
                    record.initial_bid_price_unit_rate
                );
                const isFirstEntry = (record) => {
                  const sameMaterialTypeRecords = tableData.filter(
                    (item) => item.material_type === record.material_type
                  );
                  return sameMaterialTypeRecords.indexOf(record) === 0;
                };

                return (
                  <div>
                    {record?.siteName === "Sub-Total" ? (
                      <div style={{ marginLeft: "1px" }}> </div>
                    ) : record?.siteName === "City-Total" ? (
                      <div style={{ marginLeft: "1px" }}> </div>
                    ) : currentStep !== 0 &&
                      record?.siteName !== "Sub-Total" ? (
                      <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                        {initialBidDates &&
                        record.initial_bid_price_unit_rate === 0
                          ? "Not Quoted"
                          : `₹ ${record.initial_bid_price_unit_rate}` ?? ""}
                      </div>
                    ) : (
                      <>
                        <Input
                          name={`initial_bid_price_unit_rate_${record.material_type}`}
                          value={record.initial_bid_price_unit_rate ?? ""}
                          maxLength={5}
                          prefix={<RupeesSign />}
                          onChange={(e) => {
                            handleInputChange(
                              e,
                              record.siteId,
                              record.material_type,
                              "initial_bid_price_unit_rate"
                            );
                            handleUnitRateChange(
                              e.target.value,
                              record.siteId,
                              record.material_type,
                              record.city_id
                            );
                          }}
                          disabled={currentStep !== 0}
                          required
                          style={{
                            width: "80px",
                            borderColor:
                              !isValueConsistent && currentStep === 0
                                ? "red"
                                : "",
                            borderWidth:
                              !isValueConsistent && currentStep === 0
                                ? "2px"
                                : "",
                          }}
                        />
                        {!isValueConsistent &&
                          currentStep === 0 &&
                          !isFirstEntry(record) && (
                            <Tooltip title="The unit rate is different for the same material">
                              <InfoCircleOutlined
                                style={{ color: "red", marginLeft: "5px" }}
                              />
                            </Tooltip>
                          )}
                      </>
                    )}
                  </div>
                );
              },
            },

            showUnitRateOfFreight && {
              title: "Unit Rate Freight",
              dataIndex: "initial_bid_price_unit_rate_of_freight",
              key: "initial_bid_price_unit_rate_of_freight",
              width: "100px",
              align: "right",
              render: (text, record) => {
                const allRecords = tableData;
                const sameMaterialTypeRecords = allRecords.filter(
                  (item) => item.material_type === record.material_type
                );

                const isValueConsistent = sameMaterialTypeRecords.every(
                  (item) =>
                    item.initial_bid_price_unit_rate_of_freight ===
                    record.initial_bid_price_unit_rate_of_freight
                );
                const isFirstEntry = (record) => {
                  const sameMaterialTypeRecords = tableData.filter(
                    (item) => item.material_type === record.material_type
                  );
                  return sameMaterialTypeRecords.indexOf(record) === 0;
                };

                return (
                  <div>
                    {record?.siteName === "Sub-Total" ? (
                      <div style={{ marginLeft: "1px" }}></div>
                    ) : record?.siteName === "City-Total" ? (
                      <div style={{ marginLeft: "1px" }}></div>
                    ) : currentStep !== 0 &&
                      record?.siteName !== "Sub-Total" ? (
                      <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                        {initialBidDates &&
                        record.initial_bid_price_unit_rate_of_freight === 0
                          ? "Not Quoted"
                          : `₹ ${record.initial_bid_price_unit_rate_of_freight}` ??
                            ""}
                      </div>
                    ) : (
                      <>
                        <Input
                          name={`initial_bid_price_unit_rate_of_freight_${record.material_type}`}
                          value={
                            record.initial_bid_price_unit_rate_of_freight ?? ""
                          }
                          prefix={<RupeesSign />}
                          maxLength={5}
                          onChange={(e) => {
                            handleInputChange(
                              e,
                              record.siteId,
                              record.material_type,
                              "initial_bid_price_unit_rate_of_freight"
                            );
                            handleUnitRateChange(
                              e.target.value,
                              record.siteId,
                              record.material_type,
                              record.city_id,
                              true
                            );
                          }}
                          disabled={currentStep !== 0}
                          style={{
                            width: "80px",
                          }}
                        />
                      </>
                    )}
                  </div>
                );
              },
            },

            showUnitRateOfCement && {
              title: "Amount",
              dataIndex: "initial_bid_price_amount",
              key: "initial_bid_price_amount",
              width: "130px",
              align: "right",
              render: (text, record) => {
                const isSubtotal = record.isSubtotal;

                const allRecords = tableData;

                const sameMaterialTypeRecords = allRecords.filter(
                  (item) => item.material_type === record.material_type
                );

                const isValueConsistent = sameMaterialTypeRecords.every(
                  (item) =>
                    item.initial_bid_price_unit_rate ===
                    record.initial_bid_price_unit_rate
                );
                const isFirstEntry = (record) => {
                  const sameMaterialTypeRecords = tableData.filter(
                    (item) => item.material_type === record.material_type
                  );
                  return sameMaterialTypeRecords.indexOf(record) === 0;
                };

                return record?.siteName === "Sub-Total" ? (
                  <div className="subtotal1" style={{ marginLeft: "1px" }}>
                    ₹{" "}
                    {record.total_initial_bid_price_unit_rate?.toLocaleString(
                      "en-IN"
                    ) ?? "0"}
                  </div>
                ) : record?.siteName === "City-Total" ? (
                  <div className="citytotal2" style={{ marginLeft: "1px" }}>
                    ₹{" "}
                    {record.total_initial_bid_price_unit_rate?.toLocaleString(
                      "en-IN",
                      { maximumFractionDigits: 0 }
                    ) ?? "0"}
                  </div>
                ) : currentStep !== 0 && record?.siteName !== "Sub-Total" ? (
                  <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                    {initialBidDates && record.initial_bid_price_amount === 0
                      ? "Not Quoted"
                      : `₹ ${
                          record.initial_bid_price_amount?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          ) ?? "0"
                        }` ?? ""}
                  </div>
                ) : (
                  <div className="normal-field" style={{ marginLeft: "1px" }}>
                    ₹{" "}
                    {record.initial_bid_price_amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    }) ??
                      "0" ??
                      ""}
                  </div>
                );
              },
            },
            showUnitRateOfCement && {
              title: "Unit Rate With GST",
              dataIndex: "unit_rate_with_gst",
              key: "unit_rate_with_gst",
              width: "130px",
              align: "right",
              render: (text, record) => {
                const isSubtotal = record.isSubtotal;
                let grandTotal = 0;
                if (!isSubtotal) {
                  grandTotal = tableData
                    .filter(
                      (row) => row.siteId === record.siteId && !row.isSubtotal
                    )
                    .reduce(
                      (acc, curr) =>
                        acc + (parseFloat(curr.unit_rate_with_gst) || 0),
                      0
                    );
                }
                return (
                  <>
                    {record?.siteName === "City-Total" ? (
                      ""
                    ) : record?.siteName !== "Sub-Total" ? (
                      <div
                        className="normal-field"
                        style={{ marginLeft: "1px" }}
                      >
                        {initialBidDates && record.unit_rate_with_gst === 0
                          ? "Not Quoted"
                          : `₹ ${record.unit_rate_with_gst?.toFixed(2) ?? 0}`}
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              },
            },
          ].filter(Boolean),
        }
      );
    } else {
      if (initialBidDates) {
        columns.push(
          !hideR1 &&
            currentStep >= 1 && {
              title: (
                <>
                  <Tooltip
                    color="#094E8F"
                    placement="top"
                    title={"R1 - Revised BID"}
                  >
                    <span>R1 (Without GST)</span>{" "}
                    {revisedBidDates ? `(${revisedBidDates})` : ""}
                  </Tooltip>
                </>
              ),
              children: [
                showUnitRateOfCement && {
                  title: "Unit Rate",
                  dataIndex: "revised_bid_price_unit_rate",
                  key: "revised_bid_price_unit_rate",
                  width: "120px",
                  // align: 'right',
                  render: (text, record) => {
                    const isSubtotal = record.isSubtotal;
                    let grandTotal = 0;
                    grandTotal += record.revised_bid_price_unit_rate;

                    const allRecords = tableData;
                    const sameMaterialTypeRecords = allRecords.filter(
                      (item) => item.material_type === record.material_type
                    );

                    const isValueConsistent = sameMaterialTypeRecords.every(
                      (item) =>
                        item.revised_bid_price_unit_rate ===
                        record.revised_bid_price_unit_rate
                    );
                    const isFirstEntry = (record) => {
                      const sameMaterialTypeRecords = tableData.filter(
                        (item) => item.material_type === record.material_type
                      );
                      return sameMaterialTypeRecords.indexOf(record) === 0;
                    };

                    return (
                      <div>
                        {record?.siteName === "Sub-Total" ? (
                          <div style={{ marginLeft: "1px" }}> </div>
                        ) : record?.siteName === "City-Total" ? (
                          <div style={{ marginLeft: "1px" }}> </div>
                        ) : currentStep !== 1 &&
                          record?.siteName !== "Sub-Total" ? (
                          <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                            ₹ {record.revised_bid_price_unit_rate ?? ""}
                          </div>
                        ) : (
                          <>
                            <Input
                              name={`revised_bid_price_unit_rate_${record.material_type}`}
                              value={record.revised_bid_price_unit_rate ?? ""}
                              prefix={<RupeesSign />}
                              maxLength={5}
                              onChange={(e) => {
                                handleInputChange(
                                  e,
                                  record.siteId,
                                  record.material_type,
                                  "revised_bid_price_unit_rate"
                                );
                                handleUnitRateR1Change(
                                  e.target.value,
                                  record.siteId,
                                  record.material_type,
                                  record.city_id
                                );
                              }}
                              disabled={currentStep !== 1}
                              style={{
                                width: "80px",
                                borderColor: !isValueConsistent
                                  ? "#a9e7ff"
                                  : "",
                                borderWidth: !isValueConsistent ? "2px" : "",
                              }}
                            />
                            {!isValueConsistent && !isFirstEntry(record) && (
                              <Tooltip title="The unit rate is different for the same material">
                                <InfoCircleOutlined
                                  style={{
                                    color: "#094E8F",
                                    marginLeft: "5px",
                                  }}
                                />
                              </Tooltip>
                            )}
                          </>
                        )}
                      </div>
                    );
                  },
                },
                showUnitRateOfFreight && {
                  title: "Unit Rate Freight",
                  dataIndex: "revised_bid_price_unit_rate_of_freight",
                  key: "revised_bid_price_unit_rate_of_freight",
                  width: "100px",
                  render: (text, record) => {
                    const isSubtotal = record.isSubtotal;
                    let grandTotal = 0;
                    grandTotal += record.revised_bid_price_unit_rate_of_freight;

                    const allRecords = tableData;
                    const sameMaterialTypeRecords = allRecords.filter(
                      (item) => item.material_type === record.material_type
                    );

                    const isValueConsistent = sameMaterialTypeRecords.every(
                      (item) =>
                        item.revised_bid_price_unit_rate_of_freight ===
                        record.revised_bid_price_unit_rate_of_freight
                    );
                    const isFirstEntry = (record) => {
                      const sameMaterialTypeRecords = tableData.filter(
                        (item) => item.material_type === record.material_type
                      );
                      return sameMaterialTypeRecords.indexOf(record) === 0;
                    };

                    return (
                      <div>
                        {record?.siteName === "Sub-Total" ? (
                          <div style={{ marginLeft: "1px" }}></div>
                        ) : record?.siteName === "City-Total" ? (
                          <div style={{ marginLeft: "1px" }}></div>
                        ) : currentStep !== 1 &&
                          record?.siteName !== "Sub-Total" ? (
                          <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                            ₹{" "}
                            {record.revised_bid_price_unit_rate_of_freight?.toLocaleString(
                              "en-IN"
                            ) ?? ""}
                          </div>
                        ) : (
                          <>
                            <Input
                              name={`revised_bid_price_unit_rate_of_freight_${record.material_type}`}
                              value={
                                record.revised_bid_price_unit_rate_of_freight ??
                                ""
                              }
                              prefix={<RupeesSign />}
                              maxLength={5}
                              onChange={(e) => {
                                handleInputChange(
                                  e,
                                  record.siteId,
                                  record.material_type,
                                  "revised_bid_price_unit_rate_of_freight"
                                );
                                handleUnitRateR1Change(
                                  e.target.value,
                                  record.siteId,
                                  record.material_type,
                                  record.city_id
                                );
                              }}
                              disabled={currentStep !== 1}
                              style={{
                                width: "80px",
                              }}
                            />
                          </>
                        )}
                      </div>
                    );
                  },
                },

                showUnitRateOfCement && {
                  title: "Amount",
                  dataIndex: "revised_bid_price_amount",
                  key: "revised_bid_price_amount",
                  width: "130px",
                  align: "right",
                  render: (text, record) => {
                    const isSubtotal = record.isSubtotal;

                    const allRecords = tableData;

                    const sameMaterialTypeRecords = allRecords.filter(
                      (item) => item.material_type === record.material_type
                    );

                    const isValueConsistent = sameMaterialTypeRecords.every(
                      (item) =>
                        item.initial_bid_price_unit_rate ===
                        record.initial_bid_price_unit_rate
                    );
                    const isFirstEntry = (record) => {
                      const sameMaterialTypeRecords = tableData.filter(
                        (item) => item.material_type === record.material_type
                      );
                      return sameMaterialTypeRecords.indexOf(record) === 0;
                    };

                    return record?.siteName === "Sub-Total" ? (
                      <div className="subtotal1" style={{ marginLeft: "1px" }}>
                        ₹{" "}
                        {record.total_revised_bid_price_unit_rate?.toLocaleString(
                          "en-IN"
                        ) ?? "0"}
                      </div>
                    ) : record?.siteName === "City-Total" ? (
                      <div className="citytotal2" style={{ marginLeft: "1px" }}>
                        ₹{" "}
                        {record.total_revised_bid_price_unit_rate?.toLocaleString(
                          "en-IN",
                          { maximumFractionDigits: 0 }
                        ) ?? "0"}
                      </div>
                    ) : currentStep !== 0 &&
                      record?.siteName !== "Sub-Total" ? (
                      <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                        ₹{" "}
                        {record.revised_bid_price_amount?.toLocaleString(
                          "en-IN"
                        ) ?? ""}
                      </div>
                    ) : (
                      <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                        ₹{" "}
                        {record.revised_bid_price_amount?.toLocaleString(
                          "en-IN"
                        ) ?? ""}
                      </div>
                    );
                    //}
                  },
                },
                showUnitRateOfCement && {
                  title: "Unit Rate With GST",
                  dataIndex: "unit_rate_with_gst_revised",
                  key: "unit_rate_with_gst_revised",
                  width: "130px",
                  align: "right",
                  render: (text, record) => {
                    const isSubtotal = record.isSubtotal;
                    let grandTotal = 0;
                    if (!isSubtotal) {
                      grandTotal = tableData
                        .filter(
                          (row) =>
                            row.siteId === record.siteId && !row.isSubtotal
                        )
                        .reduce(
                          (acc, curr) =>
                            acc +
                            (parseFloat(curr.unit_rate_with_gst_revised) || 0),
                          0
                        );
                    }
                    return (
                      <>
                        {record?.siteName === "City-Total" ? (
                          ""
                        ) : record?.siteName !== "Sub-Total" ? (
                          <div
                            className="normal-field"
                            style={{ marginLeft: "1px" }}
                          >
                            {" "}
                            {revisedBidDates &&
                            record.unit_rate_with_gst_revised === 0
                              ? "Not Quoted"
                              : `₹ ${
                                  record.unit_rate_with_gst_revised?.toFixed(
                                    2
                                  ) ?? 0
                                }`}
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    );
                  },
                },
              ].filter(Boolean),
            },
          !hideR0 && {
            title: (
              <>
                <Tooltip
                  color="#094E8F"
                  placement="top"
                  title={"R0 - Initial BID"}
                >
                  <span>R0 (Without GST)</span>{" "}
                  {!hideR1 && currentStep >= 1 ? `(${initialBidDates})` : ""}
                </Tooltip>
              </>
            ),
            children: [
              showUnitRateOfCement && {
                title: "Unit Rate",
                dataIndex: "initial_bid_price_unit_rate",
                key: "initial_bid_price_unit_rate",
                width: "95px",

                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;
                  const allRecords = tableData;

                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.initial_bid_price_unit_rate ===
                      record.initial_bid_price_unit_rate
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return (
                    <div>
                      {record?.siteName === "Sub-Total" ? (
                        <div style={{ marginLeft: "1px" }}> </div>
                      ) : record?.siteName === "City-Total" ? (
                        <div style={{ marginLeft: "1px" }}> </div>
                      ) : currentStep !== 0 &&
                        record?.siteName !== "Sub-Total" ? (
                        <div
                          style={{
                            marginLeft: "1px",
                            marginTop: "3px",
                            textAlign: "end",
                          }}
                        >
                          {initialBidDates &&
                          record.initial_bid_price_unit_rate === 0
                            ? "Not Quoted"
                            : `₹ ${record.initial_bid_price_unit_rate}` ?? ""}
                        </div>
                      ) : (
                        <>
                          <Input
                            name={`initial_bid_price_unit_rate_${record.material_type}`}
                            value={record.initial_bid_price_unit_rate ?? ""}
                            prefix={<RupeesSign />}
                            maxLength={5}
                            onChange={(e) => {
                              handleInputChange(
                                e,
                                record.siteId,
                                record.material_type,
                                "initial_bid_price_unit_rate"
                              );
                              handleUnitRateChange(
                                e.target.value,
                                record.siteId,
                                record.material_type,
                                record.city_id
                              );
                            }}
                            disabled={currentStep !== 0}
                            required
                            style={{
                              width: "80px",
                              borderColor:
                                !isValueConsistent && currentStep === 0
                                  ? "#a9e7ff"
                                  : "",
                              borderWidth:
                                !isValueConsistent && currentStep === 0
                                  ? "2px"
                                  : "",
                            }}
                          />
                          {!isValueConsistent &&
                            currentStep === 0 &&
                            !isFirstEntry(record) && (
                              <Tooltip title="The unit rate is different for the same material">
                                <InfoCircleOutlined
                                  style={{
                                    color: "#094E8F",
                                    marginLeft: "5px",
                                  }}
                                />
                              </Tooltip>
                            )}
                        </>
                      )}
                    </div>
                  );
                },
              },

              showUnitRateOfFreight && {
                title: "Unit Rate Freight",
                dataIndex: "initial_bid_price_unit_rate_of_freight",
                key: "initial_bid_price_unit_rate_of_freight",
                width: "100px",

                render: (text, record) => {
                  const allRecords = tableData;
                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.initial_bid_price_unit_rate_of_freight ===
                      record.initial_bid_price_unit_rate_of_freight
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return (
                    <div>
                      {record?.siteName === "Sub-Total" ? (
                        <div style={{ marginLeft: "1px" }}></div>
                      ) : record?.siteName === "City-Total" ? (
                        <div style={{ marginLeft: "1px" }}></div>
                      ) : currentStep !== 0 &&
                        record?.siteName !== "Sub-Total" ? (
                        <div
                          style={{
                            marginLeft: "1px",
                            marginTop: "3px",
                            textAlign: "end",
                          }}
                        >
                          {initialBidDates &&
                          record.initial_bid_price_unit_rate_of_freight === 0
                            ? "Not Quoted"
                            : `₹ ${record.initial_bid_price_unit_rate_of_freight}` ??
                              ""}
                        </div>
                      ) : (
                        <>
                          <Input
                            name={`initial_bid_price_unit_rate_of_freight_${record.material_type}`}
                            value={
                              record.initial_bid_price_unit_rate_of_freight ??
                              ""
                            }
                            prefix={<RupeesSign />}
                            maxLength={5}
                            onChange={(e) => {
                              handleInputChange(
                                e,
                                record.siteId,
                                record.material_type,
                                "initial_bid_price_unit_rate_of_freight"
                              );
                              handleUnitRateChange(
                                e.target.value,
                                record.siteId,
                                record.material_type,
                                record.city_id,
                                true
                              );
                            }}
                            disabled={currentStep !== 0}
                            style={{
                              width: "80px",
                            }}
                          />
                        </>
                      )}
                    </div>
                  );
                },
              },

              showUnitRateOfCement && {
                title: "Amount",
                dataIndex: "initial_bid_price_amount",
                key: "initial_bid_price_amount",
                width: "130px",
                align: "right",
                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;

                  const allRecords = tableData;

                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.initial_bid_price_unit_rate ===
                      record.initial_bid_price_unit_rate
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return record?.siteName === "Sub-Total" ? (
                    <div className="subtotal1" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.total_initial_bid_price_unit_rate?.toLocaleString(
                        "en-IN"
                      ) ?? "0"}
                    </div>
                  ) : record?.siteName === "City-Total" ? (
                    <div className="citytotal2" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.total_initial_bid_price_unit_rate?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 0 }
                      ) ?? "0"}
                    </div>
                  ) : currentStep !== 0 && record?.siteName !== "Sub-Total" ? (
                    <div style={{ marginTop: "3px", marginRight: "5px" }}>
                      {initialBidDates && record.initial_bid_price_amount === 0
                        ? "Not Quoted"
                        : `₹ ${
                            record.initial_bid_price_amount?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            ) ?? "0"
                          }` ?? ""}
                    </div>
                  ) : (
                    <div className="normal-field" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.initial_bid_price_amount?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 0 }
                      ) ??
                        "0" ??
                        ""}
                    </div>
                  );
                  //}
                },
              },
              showUnitRateOfCement && {
                title: "Unit Rate With GST",
                dataIndex: "unit_rate_with_gst",
                key: "unit_rate_with_gst",
                width: "130px",
                align: "right",
                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;
                  let grandTotal = 0;
                  if (!isSubtotal) {
                    grandTotal = tableData
                      .filter(
                        (row) => row.siteId === record.siteId && !row.isSubtotal
                      )
                      .reduce(
                        (acc, curr) =>
                          acc + (parseFloat(curr.unit_rate_with_gst) || 0),
                        0
                      );
                  }
                  return (
                    <>
                      {record?.siteName === "City-Total" ? (
                        ""
                      ) : record?.siteName !== "Sub-Total" ? (
                        <div
                          className="normal-field"
                          style={{ marginLeft: "1px" }}
                        >
                          {initialBidDates && record.unit_rate_with_gst === 0
                            ? "Not Quoted"
                            : `₹ ${record.unit_rate_with_gst?.toFixed(2) ?? 0}`}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  );
                },
              },
            ].filter(Boolean),
          }
        );
      } else {
        columns.push(
          !hideR0 && {
            title: (
              <>
                <Tooltip
                  color="#094E8F"
                  placement="top"
                  title={"R0 - Initial BID"}
                >
                  <span>R0 (Without GST)</span>{" "}
                  {!hideR1 && currentStep >= 1 ? `(${initialBidDates})` : ""}
                </Tooltip>
              </>
            ),
            children: [
              showUnitRateOfCement && {
                title: "Unit Rate",
                dataIndex: "initial_bid_price_unit_rate",
                key: "initial_bid_price_unit_rate",
                width: "95px",

                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;
                  const allRecords = tableData;

                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.initial_bid_price_unit_rate ===
                      record.initial_bid_price_unit_rate
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return (
                    <div>
                      {record?.siteName === "Sub-Total" ? (
                        <div style={{ marginLeft: "1px" }}> </div>
                      ) : record?.siteName === "City-Total" ? (
                        <div style={{ marginLeft: "1px" }}> </div>
                      ) : currentStep !== 0 &&
                        record?.siteName !== "Sub-Total" ? (
                        <div style={{ marginLeft: "1px", marginTop: "3px" }}>
                          ₹ {record.initial_bid_price_unit_rate ?? ""}
                        </div>
                      ) : (
                        <>
                          <Input
                            name={`initial_bid_price_unit_rate_${record.material_type}`}
                            value={record.initial_bid_price_unit_rate ?? ""}
                            prefix={<RupeesSign />}
                            maxLength={5}
                            onChange={(e) => {
                              handleInputChange(
                                e,
                                record.siteId,
                                record.material_type,
                                "initial_bid_price_unit_rate"
                              );
                              handleUnitRateChange(
                                e.target.value,
                                record.siteId,
                                record.material_type,
                                record.city_id
                              );
                            }}
                            disabled={currentStep !== 0}
                            required
                            style={{
                              width: "80px",
                              borderColor:
                                !isValueConsistent && currentStep === 0
                                  ? "red"
                                  : "",
                              borderWidth:
                                !isValueConsistent && currentStep === 0
                                  ? "2px"
                                  : "",
                            }}
                          />
                          {!isValueConsistent &&
                            currentStep === 0 &&
                            !isFirstEntry(record) && (
                              <Tooltip title="The unit rate is different for the same material">
                                <InfoCircleOutlined
                                  style={{
                                    color: "#094E8F",
                                    marginLeft: "5px",
                                  }}
                                />
                              </Tooltip>
                            )}
                        </>
                      )}
                    </div>
                  );
                },
              },

              showUnitRateOfFreight && {
                title: "Unit Rate Freight",
                dataIndex: "initial_bid_price_unit_rate_of_freight",
                key: "initial_bid_price_unit_rate_of_freight",
                width: "100px",

                render: (text, record) => {
                  const allRecords = tableData;
                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.initial_bid_price_unit_rate_of_freight ===
                      record.initial_bid_price_unit_rate_of_freight
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return (
                    <div>
                      {record?.siteName === "Sub-Total" ? (
                        <div style={{ marginLeft: "1px" }}></div>
                      ) : record?.siteName === "City-Total" ? (
                        <div style={{ marginLeft: "1px" }}></div>
                      ) : currentStep !== 0 &&
                        record?.siteName !== "Sub-Total" ? (
                        <div
                          style={{
                            marginLeft: "1px",
                            marginTop: "3px",
                            textAlign: "end",
                          }}
                        >
                          {initialBidDates &&
                          record.initial_bid_price_unit_rate_of_freight === 0
                            ? "Not Quoted"
                            : `₹ ${record.initial_bid_price_unit_rate_of_freight}` ??
                              ""}
                        </div>
                      ) : (
                        <>
                          <Input
                            name={`initial_bid_price_unit_rate_of_freight_${record.material_type}`}
                            value={
                              record.initial_bid_price_unit_rate_of_freight ??
                              ""
                            }
                            prefix={<RupeesSign />}
                            maxLength={5}
                            onChange={(e) => {
                              handleInputChange(
                                e,
                                record.siteId,
                                record.material_type,
                                "initial_bid_price_unit_rate_of_freight"
                              );
                              handleUnitRateChange(
                                e.target.value,
                                record.siteId,
                                record.material_type,
                                record.city_id,
                                true
                              );
                            }}
                            disabled={currentStep !== 0}
                            style={{
                              width: "80px",
                            }}
                          />
                        </>
                      )}
                    </div>
                  );
                },
              },

              showUnitRateOfCement && {
                title: "Amount",
                dataIndex: "initial_bid_price_amount",
                key: "initial_bid_price_amount",
                width: "130px",
                align: "right",
                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;

                  const allRecords = tableData;

                  const sameMaterialTypeRecords = allRecords.filter(
                    (item) => item.material_type === record.material_type
                  );

                  const isValueConsistent = sameMaterialTypeRecords.every(
                    (item) =>
                      item.initial_bid_price_unit_rate ===
                      record.initial_bid_price_unit_rate
                  );
                  const isFirstEntry = (record) => {
                    const sameMaterialTypeRecords = tableData.filter(
                      (item) => item.material_type === record.material_type
                    );
                    return sameMaterialTypeRecords.indexOf(record) === 0;
                  };

                  return record?.siteName === "Sub-Total" ? (
                    <div className="subtotal1" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.total_initial_bid_price_unit_rate?.toLocaleString(
                        "en-IN"
                      ) ?? "0"}
                    </div>
                  ) : record?.siteName === "City-Total" ? (
                    <div className="citytotal2" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.total_initial_bid_price_unit_rate?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 0 }
                      ) ?? "0"}
                    </div>
                  ) : currentStep !== 0 && record?.siteName !== "Sub-Total" ? (
                    <div style={{ marginTop: "3px", marginRight: "5px" }}>
                      {initialBidDates && record.initial_bid_price_amount === 0
                        ? "Not Quoted"
                        : `₹ ${
                            record.initial_bid_price_amount?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            ) ?? "0"
                          }` ?? ""}
                    </div>
                  ) : (
                    <div className="normal-field" style={{ marginLeft: "1px" }}>
                      ₹{" "}
                      {record.initial_bid_price_amount?.toLocaleString(
                        "en-IN",
                        { maximumFractionDigits: 0 }
                      ) ??
                        "0" ??
                        ""}
                    </div>
                  );
                  //}
                },
              },
              showUnitRateOfCement && {
                title: "Unit Rate With GST",
                dataIndex: "unit_rate_with_gst",
                key: "unit_rate_with_gst",
                width: "130px",
                align: "right",
                render: (text, record) => {
                  const isSubtotal = record.isSubtotal;
                  let grandTotal = 0;
                  if (!isSubtotal) {
                    grandTotal = tableData
                      .filter(
                        (row) => row.siteId === record.siteId && !row.isSubtotal
                      )
                      .reduce(
                        (acc, curr) =>
                          acc + (parseFloat(curr.unit_rate_with_gst) || 0),
                        0
                      );
                  }
                  return (
                    <>
                      {record?.siteName === "City-Total" ? (
                        ""
                      ) : record?.siteName !== "Sub-Total" ? (
                        <div
                          className="normal-field"
                          style={{ marginLeft: "1px" }}
                        >
                          {initialBidDates && record.unit_rate_with_gst === 0
                            ? "Not Quoted"
                            : `₹ ${record.unit_rate_with_gst?.toFixed(2) ?? 0}`}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  );
                },
              },
            ].filter(Boolean),
          }
        );
      }
    }

    return columns.filter(Boolean).map((col) => ({
      ...col,
      filterDropdown: col.filterDropdown || null,
    }));
  };

  const columns = getColumns();

  const columns2 = [
    {
      title: "City Name",
      dataIndex: "city_name",
      key: "city_name",
      render: (text, record) => <span>{record.city_name}</span>,
    },
    {
      title: "Site Name",
      dataIndex: "site_name",
      key: "site_name",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <Input
              disabled
              key={site.site_id}
              value={site.site_name}
              className="InputItem"
            />
          ))}
        </div>
      ),
    },
    {
      title: "Amount With GST",
      dataIndex: "amount_with_gst",
      key: "amount_with_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_with_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
    {
      title: "Amount Without GST",
      dataIndex: "amount_without_gst",
      key: "amount_without_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_without_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
  ];

  const getColumns3 = () => {
    const columns3 = [
      {
        title: "City",
        dataIndex: "city",
        key: "city",
        width: 120,
        fixed: "left",
      },
      {
        title: "Site",
        dataIndex: "sites",
        key: "site",
        width: 130,
        fixed: "left",
        render: (sites, record) => {
          if (record.site === "Total") {
            return <div className="total3">Total</div>;
          }

          return (
            <div>
              {Array.isArray(sites) && sites.length > 0
                ? sites[0].site
                : "No site data"}
            </div>
          );
        },
      },
    ].filter(Boolean);

    if (revisedBidDates) {
      columns3.push(
        !hideR &&
          currentStep >= 2 && {
            title: "R",
            children: [
              {
                title: "Amount Without GST",
                dataIndex: "sites",
                key: "amountWithoutGstR",
                width: 150,
                align: "right",
                render: (sites, record) => {
                  if (record.site === "Total") {
                    return (
                      <div className="total3">
                        {`₹
                        ${record.totalAmountWithoutGstR?.toLocaleString(
                          "en-IN",
                          {
                            maximumFractionDigits: 0,
                          }
                        )}`}
                      </div>
                    );
                  } else {
                    const percentage = sites[0]?.percentageWithoutGstR || 0;
                    return (
                      <div>
                        ₹{" "}
                        {sites.length > 0
                          ? sites[0].totalAmountWithoutGstR?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            )
                          : "0.00"}{" "}
                        ({percentage}%)
                      </div>
                    );
                  }
                },
              },
              {
                title: "Amount With GST",
                dataIndex: "sites",
                key: "amountWithGstR",
                width: 150,
                align: "right",
                render: (sites, record) => {
                  if (record.site === "Total") {
                    return (
                      <div className="total3">
                        {`₹
                      ${record.totalAmountWithGstR?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                      </div>
                    );
                  } else {
                    const percentage = sites[0]?.percentageWithGstR || 0;
                    return (
                      <div>
                        ₹{" "}
                        {sites.length > 0
                          ? sites[0].totalAmountWithGstR?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            )
                          : "0.00"}{" "}
                        ({percentage}%)
                      </div>
                    );
                  }
                },
              },
            ].filter(Boolean),
          },
        !hideR1 &&
          currentStep >= 1 && {
            title: "R1",
            children: [
              {
                title: "Amount Without GST",
                dataIndex: "sites",
                key: "amountWithoutGstR1",
                width: 150,
                align: "right",
                render: (sites, record) => {
                  if (record.site === "Total") {
                    return (
                      <div className="total3">
                        {`₹
                    ${record.totalAmountWithoutGstR1?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                      </div>
                    );
                  } else {
                    const percentage = sites[0]?.percentageWithoutGstR1 || 0;
                    return (
                      <div>
                        ₹{" "}
                        {sites.length > 0
                          ? sites[0].totalAmountWithoutGstR1?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            )
                          : "0.00"}
                        {""}({percentage}%)
                      </div>
                    );
                  }
                },
              },
              {
                title: "Amount With GST",
                dataIndex: "sites",
                key: "amountWithGstR1",
                width: 150,
                align: "right",
                render: (sites, record) => {
                  if (record.site === "Total") {
                    return (
                      <div className="total3">
                        {`₹
                    ${record.totalAmountWithGstR1?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                      </div>
                    );
                  } else {
                    const percentage = sites[0]?.percentageWithGstR1 || 0;
                    return (
                      <div>
                        ₹{" "}
                        {sites.length > 0
                          ? sites[0].totalAmountWithGstR1?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            )
                          : "0.00"}
                        {""}({percentage}%)
                      </div>
                    );
                  }
                },
              },
            ].filter(Boolean),
          },
        !hideR0 && {
          title: "R0",
          children: [
            {
              title: "Amount Without GST",
              dataIndex: "sites",
              key: "amountWithoutGstR0",
              width: 150,
              align: "right",
              render: (sites, record) => {
                let val = 0;
                if (record.site === "Total") {
                  val = record.totalAmountWithoutGstR0;
                  const total = record.totalAmountWithoutGstR0 || 0;
                  const grandTotal = record.totalAmountWithoutGstR0 || 0;
                  const percentage = grandTotal
                    ? ((total / grandTotal) * 100).toFixed(2)
                    : 0;

                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}${" "}`}
                    </div>
                  );
                } else {
                  const amount =
                    sites.length > 0
                      ? sites[0].totalAmountWithoutGstR0 || 0
                      : 0;
                  const grandTotal = record.totalAmountWithoutGstR0 + val;

                  const percentage = sites[0]?.percentageWithoutGst || 0;

                  return (
                    <div>
                      {`₹
                      ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}${" "}
                      (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
            {
              title: "Amount With GST",
              dataIndex: "sites",
              key: "amountWithGstR0",
              width: 150,
              align: "right",
              render: (sites, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithGstR0 || 0;
                  const grandTotal = record.totalAmountWithGstR0;
                  const percentage = grandTotal
                    ? ((total / grandTotal) * 100).toFixed(2)
                    : 0;

                  return (
                    <div className="total3">
                      {`₹
                      ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}${" "}`}
                    </div>
                  );
                } else {
                  const amount =
                    sites.length > 0 ? sites[0].totalAmountWithGstR0 || 0 : 0;
                  const grandTotal = record.totalAmountWithGstR0;

                  const percentage = sites[0]?.percentageWithGst || 0;

                  return (
                    <div>
                      {`₹
                      ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}${" "}
                      (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
          ].filter(Boolean),
        }
      );
    } else {
      if (initialBidDates) {
        columns3.push(
          !hideR1 &&
            currentStep >= 1 && {
              title: "R1",
              children: [
                {
                  title: "Amount Without GST",
                  dataIndex: "sites",
                  key: "amountWithoutGstR1",
                  width: 200,
                  align: "right",
                  render: (sites, record) => {
                    if (record.site === "Total") {
                      return (
                        <div className="total3">
                          {`₹
                    ${record.totalAmountWithoutGstR1?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                        </div>
                      );
                    } else {
                      const percentage = sites[0]?.percentageWithoutGstR1 || 0;
                      return (
                        <div>
                          ₹{" "}
                          {sites.length > 0
                            ? sites[0].totalAmountWithoutGstR1?.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "0.00"}
                          {""}({percentage}%)
                        </div>
                      );
                    }
                  },
                },
                {
                  title: "Amount With GST",
                  dataIndex: "sites",
                  key: "amountWithGstR1",
                  width: 200,
                  align: "right",
                  render: (sites, record) => {
                    if (record.site === "Total") {
                      return (
                        <div className="total3">
                          {`₹
                    ${record.totalAmountWithGstR1?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                        </div>
                      );
                    } else {
                      const percentage = sites[0]?.percentageWithGstR1 || 0;
                      return (
                        <div>
                          ₹{" "}
                          {sites.length > 0
                            ? sites[0].totalAmountWithGstR1?.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "0.00"}
                          {""}({percentage}%)
                        </div>
                      );
                    }
                  },
                },
              ].filter(Boolean),
            },
          !hideR0 && {
            title: "R0",
            children: [
              {
                title: "Amount Without GST",
                dataIndex: "sites",
                key: "amountWithoutGstR0",
                width: 200,
                align: "right",
                render: (sites, record) => {
                  let val = 0;
                  if (record.site === "Total") {
                    val = record.totalAmountWithoutGstR0;
                    const total = record.totalAmountWithoutGstR0 || 0;
                    const grandTotal = record.totalAmountWithoutGstR0 || 0;
                    const percentage = grandTotal
                      ? ((total / grandTotal) * 100).toFixed(2)
                      : 0;

                    return (
                      <div className="total3">
                        {`₹ ${total?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}${" "}`}
                      </div>
                    );
                  } else {
                    const amount =
                      sites.length > 0
                        ? sites[0].totalAmountWithoutGstR0 || 0
                        : 0;
                    const grandTotal = record.totalAmountWithoutGstR0 + val;

                    const percentage = sites[0]?.percentageWithoutGst || 0;

                    return (
                      <div>
                        {`₹
                      ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}${" "}
                      (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
              {
                title: "Amount With GST",
                dataIndex: "sites",
                key: "amountWithGstR0",
                width: 200,
                align: "right",
                render: (sites, record) => {
                  if (record.site === "Total") {
                    const total = record.totalAmountWithGstR0 || 0;
                    const grandTotal = record.totalAmountWithGstR0;
                    const percentage = grandTotal
                      ? ((total / grandTotal) * 100).toFixed(2)
                      : 0;

                    return (
                      <div className="total3">
                        {`₹
                      ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}${" "}`}
                      </div>
                    );
                  } else {
                    const amount =
                      sites.length > 0 ? sites[0].totalAmountWithGstR0 || 0 : 0;
                    const grandTotal = record.totalAmountWithGstR0;

                    const percentage = sites[0]?.percentageWithGst || 0;

                    return (
                      <div>
                        {`₹
                      ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}${" "}
                      (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
            ].filter(Boolean),
          }
        );
      } else {
        columns3.push(
          !hideR0 && {
            title: "R0",
            children: [
              {
                title: "Amount Without GST",
                dataIndex: "sites",
                key: "amountWithoutGstR0",
                width: 200,
                align: "right",
                render: (sites, record) => {
                  let val = 0;
                  if (record.site === "Total") {
                    val = record.totalAmountWithoutGstR0;
                    const total = record.totalAmountWithoutGstR0 || 0;
                    const grandTotal = record.totalAmountWithoutGstR0 || 0;
                    const percentage = grandTotal
                      ? ((total / grandTotal) * 100).toFixed(2)
                      : 0;

                    return (
                      <div className="total3">
                        {`₹ ${total?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}${" "}`}
                      </div>
                    );
                  } else {
                    const amount =
                      sites.length > 0
                        ? sites[0].totalAmountWithoutGstR0 || 0
                        : 0;
                    const grandTotal = record.totalAmountWithoutGstR0 + val;

                    const percentage = sites[0]?.percentageWithoutGst || 0;

                    return (
                      <div>
                        {`₹
                        ${amount?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}${" "}
                        (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
              {
                title: "Amount With GST",
                dataIndex: "sites",
                key: "amountWithGstR0",
                width: 200,
                align: "right",
                render: (sites, record) => {
                  if (record.site === "Total") {
                    const total = record.totalAmountWithGstR0 || 0;
                    const grandTotal = record.totalAmountWithGstR0;
                    const percentage = grandTotal
                      ? ((total / grandTotal) * 100).toFixed(2)
                      : 0;

                    return (
                      <div className="total3">
                        {`₹
                        ${total?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}${" "}`}
                      </div>
                    );
                  } else {
                    const amount =
                      sites.length > 0 ? sites[0].totalAmountWithGstR0 || 0 : 0;
                    const grandTotal = record.totalAmountWithGstR0;

                    const percentage = sites[0]?.percentageWithGst || 0;

                    return (
                      <div>
                        {`₹
                        ${amount?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}${" "}
                        (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
            ].filter(Boolean),
          }
        );
      }
    }

    return columns3.filter(Boolean);
  };

  const columns3 = getColumns3();

  useEffect(() => {
    const cityMap = new Map();

    let totalQuantity = 0;
    let totalWithGstR0 = 0;
    let totalWithoutGstR0 = 0;
    let totalWithGstR1 = 0;
    let totalWithoutGstR1 = 0;
    let totalWithGstR = 0;
    let totalWithoutGstR = 0;
    let grandTotalWithoutGstR0 = 0;
    let grandTotalWithGstR0 = 0;

    let grandTotalWithoutGstR1 = 0;
    let grandTotalWithGstR1 = 0;

    let grandTotalWithoutGstR = 0;
    let grandTotalWithGstR = 0;

    tableData.forEach((item) => {
      if (item.site_name === "Subtotal") {
        const cityKey = item.siteId;
        const cityData = cityMap.get(cityKey);

        if (cityData) {
          const subtotalData = {
            site: "Subtotal",
            totalAmountWithGst: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithGst,
              0
            ),
            totalAmountWithoutGst: cityData.sites.reduce(
              (sum, site) => sum + site.totalAmountWithoutGst,
              0
            ),
          };
          cityData.sites.push(subtotalData);
        }
      } else if (item.site_name) {
        const siteData = {
          site_id: item.siteId,
          site: item.site_name,
          totalAmountWithGstR0: 0,
          totalAmountWithoutGstR0: 0,
          totalAmountWithGstR1: 0,
          totalAmountWithoutGstR1: 0,
          totalAmountWithGstR: 0,
          totalAmountWithoutGstR: 0,
          percentageWithoutGst: 0,
          percentageWithGst: 0,
          percentageWithoutGstR1: 0,
          percentageWithoutGstR: 0,
          percentageWithGstR: 0,
        };

        const materialData = tableData.filter(
          (data) => data.siteId === item.siteId
        );

        siteData.totalAmountWithGstR0 = materialData.reduce((sum, material) => {
          const unitRate =
            parseFloat(material.initial_bid_price_unit_rate) || 0;

          const unitRateForFreight =
            parseFloat(material.initial_bid_price_unit_rate_of_freight) || 0;

          const totalAmountWithoutGstForMaterial =
            unitRate * (material.material_total_quantity || 0);

          const totalAmountWithoutGstForMaterialFreight =
            unitRateForFreight * (material.material_total_quantity || 0);

          const gstAmount =
            totalAmountWithoutGstForMaterial * ((material.gst_rate || 0) / 100);

          const gstAmountForFreight =
            totalAmountWithoutGstForMaterialFreight *
            ((material.gst_rate_freight || 0) / 100);

          const total =
            totalAmountWithoutGstForMaterial +
            gstAmount +
            (totalAmountWithoutGstForMaterialFreight + gstAmountForFreight);

          return sum + total;
        }, 0);

        siteData.totalAmountWithoutGstR0 = materialData.reduce(
          (sum, material) => {
            const unitRate =
              (parseFloat(material.initial_bid_price_unit_rate) || 0) +
              (parseFloat(material.initial_bid_price_unit_rate_of_freight) ||
                0);
            return sum + unitRate * (material.material_total_quantity || 0);
          },
          0
        );

        siteData.totalAmountWithGstR1 = materialData.reduce((sum, material) => {
          const unitRate =
            (parseFloat(material.revised_bid_price_unit_rate) || 0) +
            (parseFloat(material.revised_bid_price_unit_rate_of_freight) || 0);
          const totalAmountWithoutGstForMaterial =
            unitRate * (material.material_total_quantity || 0);

          const gstAmount =
            totalAmountWithoutGstForMaterial * ((material.gst_rate || 0) / 100);
          return sum + totalAmountWithoutGstForMaterial + gstAmount;
        }, 0);

        siteData.totalAmountWithoutGstR1 = materialData.reduce(
          (sum, material) => {
            const unitRate =
              (parseFloat(material.revised_bid_price_unit_rate) || 0) +
              (parseFloat(material.revised_bid_price_unit_rate_of_freight) ||
                0);
            return sum + unitRate * (material.material_total_quantity || 0);
          },
          0
        );

        siteData.totalAmountWithGstR = materialData.reduce((sum, material) => {
          const unitRate =
            (parseFloat(material.final_bid_price_unit_rate) || 0) +
            (parseFloat(material.final_bid_price_unit_rate_of_freight) || 0);
          const totalAmountWithoutGstForMaterial =
            unitRate * (material.material_total_quantity || 0);

          const gstAmount =
            totalAmountWithoutGstForMaterial * ((material.gst_rate || 0) / 100);
          return sum + totalAmountWithoutGstForMaterial + gstAmount;
        }, 0);

        siteData.totalAmountWithoutGstR = materialData.reduce(
          (sum, material) => {
            const unitRate =
              (parseFloat(material.final_bid_price_unit_rate) || 0) +
              (parseFloat(material.final_bid_price_unit_rate_of_freight) || 0);
            return sum + unitRate * (material.material_total_quantity || 0);
          },
          0
        );

        grandTotalWithoutGstR0 += siteData.totalAmountWithoutGstR0 || 0;
        grandTotalWithGstR0 += siteData.totalAmountWithGstR0 || 0;

        grandTotalWithoutGstR1 += siteData.totalAmountWithoutGstR1 || 0;
        grandTotalWithGstR1 += siteData.totalAmountWithGstR1 || 0;

        grandTotalWithoutGstR += siteData.totalAmountWithoutGstR || 0;
        grandTotalWithGstR += siteData.totalAmountWithGstR || 0;

        totalQuantity += item.material_total_quantity || 0;
        totalWithGstR0 += siteData.totalAmountWithGstR0;
        totalWithoutGstR0 += siteData.totalAmountWithoutGstR0;
        totalWithGstR1 += siteData.totalAmountWithGstR1;
        totalWithoutGstR1 += siteData.totalAmountWithoutGstR1;
        totalWithGstR += siteData.totalAmountWithGstR;
        totalWithoutGstR += siteData.totalAmountWithoutGstR;

        const cityKey = item.siteId;

        if (!cityMap.has(cityKey)) {
          cityMap.set(cityKey, { city: item.city_name, sites: [] });
        }

        const cityData = cityMap.get(cityKey);
        cityData.sites.push(siteData);
      }
    });

    Array.from(cityMap.values()).forEach((cityData) => {
      cityData.sites.forEach((siteData) => {
        siteData.percentageWithoutGst = grandTotalWithoutGstR0
          ? (
              (siteData.totalAmountWithoutGstR0 / grandTotalWithoutGstR0) *
              100
            ).toFixed(2)
          : "0";

        siteData.percentageWithGst = grandTotalWithGstR0
          ? (
              (siteData.totalAmountWithGstR0 / grandTotalWithGstR0) *
              100
            ).toFixed(2)
          : "0";

        siteData.percentageWithoutGstR1 = grandTotalWithoutGstR1
          ? (
              (siteData.totalAmountWithoutGstR1 / grandTotalWithoutGstR1) *
              100
            ).toFixed(2)
          : "0";

        siteData.percentageWithGstR1 = grandTotalWithGstR1
          ? (
              (siteData.totalAmountWithGstR1 / grandTotalWithGstR1) *
              100
            ).toFixed(2)
          : "0";

        siteData.percentageWithoutGstR = grandTotalWithoutGstR
          ? (
              (siteData.totalAmountWithoutGstR / grandTotalWithoutGstR) *
              100
            ).toFixed(2)
          : "0";

        siteData.percentageWithGstR = grandTotalWithGstR
          ? ((siteData.totalAmountWithGstR / grandTotalWithGstR) * 100).toFixed(
              2
            )
          : "0";
      });
    });

    const totalRow = {
      site: "Total",
      totalAmountWithGstR0: totalWithGstR0,
      totalAmountWithoutGstR0: totalWithoutGstR0,
      totalAmountWithGstR1: totalWithGstR1,
      totalAmountWithoutGstR1: totalWithoutGstR1,
      totalAmountWithGstR: totalWithGstR,
      totalAmountWithoutGstR: totalWithoutGstR,
      material_total_quantity: totalQuantity,
    };

    const finalData = Array.from(cityMap.values());
    finalData.push(totalRow);

    setSummaryTableData(finalData);
  }, [tableData, resetMode, setSummaryTableData]);


  useEffect(() => {
    const materialTotals = {};
    let sandConversion = null;
    let aggregateConversion = null;

    tableSummary.forEach((cityDetail) => {
      sandConversion = cityDetail?.sand_conversion;
      aggregateConversion = cityDetail?.aggregate_conversion;
      const key =
        cityDetail.material_wise_uom !== "Cubic Meter" &&
        cityDetail.material_type_name;
      if (!key) return;

      if (!materialTotals[key]) {
        materialTotals[key] = {
          material_type_name: cityDetail.material_type_name,
          total_weighted_price: 0,
          total_quantity_MT: 0,
          total_quantity_meter: 0,
          category_tree_name: cityDetail.category_tree_name,
        };
      }

      const baseRate =
        (cityDetail.initial_bid_price_unit_rate || 0) +
        (cityDetail.initial_bid_price_unit_rate_of_freight || 0);

      /* ===============================
       ✅ METER-BASED (EARTHING)
    =============================== */
      if (cityDetail.material_wise_uom === "meter") {
        materialTotals[key].total_quantity_meter +=
          cityDetail.material_total_quantity;

        materialTotals[key].total_weighted_price +=
          baseRate * cityDetail.material_total_quantity;

        return; // 🚨 DO NOT fall into MT logic
      }

      /* ===============================
       ✅ MT-BASED MATERIALS
    =============================== */
      let quantityMT = 0;
      let rateMT = 0;

      if (cityDetail.material_wise_uom === "MT") {
        quantityMT = cityDetail.material_total_quantity;
        rateMT = baseRate;
      } else if (cityDetail.material_wise_uom === "Cubic Meter") {
        quantityMT = cityDetail.material_total_quantity * 1.6;
        rateMT = baseRate / 1.6;
      } else if (cityDetail.material_wise_uom === "Bag") {
        quantityMT = cityDetail.material_total_quantity * 0.05;
        rateMT = baseRate / 0.05;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Sand")
      ) {
        quantityMT =
          cityDetail.material_total_quantity * cityDetail.sand_conversion;
        rateMT = baseRate / cityDetail.sand_conversion;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Aggregate")
      ) {
        quantityMT =
          cityDetail.material_total_quantity * cityDetail.aggregate_conversion;
        rateMT = baseRate / cityDetail.aggregate_conversion;
      }

      materialTotals[key].total_quantity_MT += quantityMT;
      materialTotals[key].total_weighted_price += rateMT * quantityMT;
      materialTotals[key].category_tree_name = cityDetail.category_tree_name;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const {
        total_weighted_price,
        total_quantity_MT,
        total_quantity_meter,
        category_tree_name,
      } = material;

      if (category_tree_name.includes("Earthing")) {
        const averagePriceMeter = total_quantity_meter
          ? total_weighted_price / total_quantity_meter
          : 0;

                  const isCopper = material.material_type_name
          ?.toUpperCase()
          .includes("CU");

        const isGI = material.material_type_name?.toUpperCase().includes("GI");

        const sizeMatch =
          material.material_type_name.match(/(\d+)\s*x\s*(\d+)/i);

        const width = sizeMatch ? Number(sizeMatch[1]) : 0;
        const thickness = sizeMatch ? Number(sizeMatch[2]) : 0;

        let density = 0;
        if (isCopper) density = 8960;
        else if (isGI) density = 7850;

        const kgPerMeter =
          width && thickness && density
            ? (width * thickness * density) / 1_000_000
            : 0;
            
        const averagePriceKG =
          averagePriceMeter && kgPerMeter ? averagePriceMeter / kgPerMeter : 0;

        return {
          ...material,
          averagePriceMeter,
          averagePriceKG,
          kgPerMeter,
        };
      }

      const averagePriceMT = total_quantity_MT
        ? total_weighted_price / total_quantity_MT
        : 0;

      let averagePriceCum = 0;
      if (category_tree_name.includes("Sand")) {
        averagePriceCum = averagePriceMT / (sandConversion || 1.6);
      } else if (category_tree_name.includes("Aggregate")) {
        averagePriceCum = averagePriceMT / (aggregateConversion || 1.45);
      }
      const averagePriceKG = averagePriceMT / 1000;
      return {
        ...material,
        averagePriceMT,
        averagePriceCum,
        averagePriceKG: averagePriceMT / 1000,
        averagePriceBag: averagePriceMT * 0.05,
      };
    });

    setSummaryTableData2(fattenData);
  }, [tableSummary]);

  useEffect(() => {
    const materialTotals = {};
    let sandConversion = null;
    let aggregateConversion = null;
    let isSand = false;
    let isAggregate = false;
    tableSummary.forEach((cityDetail) => {
      sandConversion = cityDetail?.sand_conversion;
      aggregateConversion = cityDetail?.aggregate_conversion;
      isSand = cityDetail?.category_tree_name?.includes("Sand") ? true : false;
      isAggregate = cityDetail?.category_tree_name?.includes("Aggregate")
        ? true
        : false;
      const key =
        cityDetail.material_wise_uom !== "Cubic Meter" &&
        cityDetail.material_type_name;

      if (!key) return;

      if (!materialTotals[key]) {
        materialTotals[key] = {
          material_type_name: cityDetail.material_type_name,
          total_weighted_price: 0,
          total_quantity_MT: 0,
          total_quantity_meter: 0,
          category_tree_name: cityDetail.category_tree_name,
        };
      }

      const baseRate =
        (cityDetail.revised_bid_price_unit_rate || 0) +
        (cityDetail.revised_bid_price_unit_rate_of_freight || 0);

      if (cityDetail.material_wise_uom === "meter") {
        materialTotals[key].total_quantity_meter +=
          cityDetail.material_total_quantity;

        materialTotals[key].total_weighted_price +=
          baseRate * cityDetail.material_total_quantity;

        return;
      }

      let quantityMT = 0;
      let rateMT = 0;

      if (cityDetail.material_wise_uom === "MT") {
        quantityMT = cityDetail.material_total_quantity;
      } else if (cityDetail.material_wise_uom === "Cubic Meter") {
        quantityMT = cityDetail.material_total_quantity * 1.6;
      } else if (cityDetail.material_wise_uom === "Bag") {
        quantityMT = cityDetail.material_total_quantity * 0.05;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Sand")
      ) {
        quantityMT =
          cityDetail.material_total_quantity * cityDetail.sand_conversion;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Aggregate")
      ) {
        quantityMT =
          cityDetail.material_total_quantity * cityDetail.aggregate_conversion;
      }

      if (cityDetail.material_wise_uom === "MT") {
        rateMT = baseRate;
      } else if (cityDetail.material_wise_uom === "Cubic Meter") {
        rateMT = baseRate / 1.6;
      } else if (cityDetail.material_wise_uom === "Bag") {
        rateMT = baseRate / 0.05;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Sand")
      ) {
        rateMT = baseRate / cityDetail.sand_conversion;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Aggregate")
      ) {
        rateMT = baseRate / cityDetail.aggregate_conversion;
      }
      const weightedPrice = rateMT * quantityMT;

      materialTotals[key].total_quantity_MT += quantityMT;
      materialTotals[key].total_weighted_price += rateMT * quantityMT;
      materialTotals[key].category_tree_name = cityDetail.category_tree_name;

      // materialTotals[key].total_weighted_price += weightedPrice;
      // materialTotals[key].total_quantity_MT += quantityMT;
      // materialTotals[key].category_tree_name = cityDetail.category_tree_name;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const {
        total_weighted_price,
        total_quantity_MT,
        total_quantity_meter,
        category_tree_name,
      } = material;

      if (category_tree_name.includes("Earthing")) {
        const averagePriceMeter = total_quantity_meter
          ? total_weighted_price / total_quantity_meter
          : 0;

 const isCopper = material.material_type_name
          ?.toUpperCase()
          .includes("CU");

        const isGI = material.material_type_name?.toUpperCase().includes("GI");

        const sizeMatch =
          material.material_type_name.match(/(\d+)\s*x\s*(\d+)/i);

        const width = sizeMatch ? Number(sizeMatch[1]) : 0;
        const thickness = sizeMatch ? Number(sizeMatch[2]) : 0;

        let density = 0;
        if (isCopper) density = 8960;
        else if (isGI) density = 7850;

        const kgPerMeter =
          width && thickness && density
            ? (width * thickness * density) / 1_000_000
            : 0;

        const averagePriceKG =
          averagePriceMeter && kgPerMeter ? averagePriceMeter / kgPerMeter : 0;

        return {
          ...material,
          averagePriceMeter,
          averagePriceKG,
          kgPerMeter
        };
      }

      const averagePriceMT = total_quantity_MT
        ? total_weighted_price / total_quantity_MT
        : 0;

      let averagePriceCum = 0;
      if (category_tree_name.includes("Sand")) {
        averagePriceCum = averagePriceMT * (1 / (sandConversion || 1.6));
      } else if (category_tree_name.includes("Aggregate")) {
        averagePriceCum = averagePriceMT * (1 / (aggregateConversion || 1.45));
      } else {
        averagePriceCum = averagePriceMT * (1 / 1.6);
      }

      const averagePriceKG = averagePriceMT / 1000;
      const averagePriceBag = averagePriceMT * 0.05;

      return {
        ...material,
        averagePriceMT,
        averagePriceCum,
        averagePriceKG: averagePriceMT / 1000,
        averagePriceBag: averagePriceMT * 0.05,
      };
    });

    setSummaryTableDataRevised(fattenData);
  }, [tableSummary]);

  useEffect(() => {
    const materialTotals = {};
    let sandConversion = null;
    let aggregateConversion = null;
    let isSand = false;
    let isAggregate = false;
    tableSummary.forEach((cityDetail) => {
      const key =
        cityDetail.material_wise_uom !== "Cubic Meter" &&
        cityDetail.material_type_name;
      sandConversion = cityDetail?.sand_conversion;
      aggregateConversion = cityDetail?.aggregate_conversion;
      isSand = cityDetail?.category_tree_name?.includes("Sand") ? true : false;
      isAggregate = cityDetail?.category_tree_name?.includes("Aggregate")
        ? true
        : false;
      if (!key) return;

      if (!materialTotals[key]) {
        materialTotals[key] = {
          material_type_name: cityDetail.material_type_name,
          total_weighted_price: 0,
          total_quantity_MT: 0,
          total_quantity_meter: 0,
          category_tree_name: cityDetail.category_tree_name,
        };
      }

      const baseRate =
        (cityDetail.final_bid_price_unit_rate || 0) +
        (cityDetail.final_bid_price_unit_rate_of_freight || 0);

      if (cityDetail.material_wise_uom === "meter") {
        materialTotals[key].total_quantity_meter +=
          cityDetail.material_total_quantity;

        materialTotals[key].total_weighted_price +=
          baseRate * cityDetail.material_total_quantity;

        return;
      }

      let rateMT = 0;
      let quantityMT = 0;

      if (cityDetail.material_wise_uom === "MT") {
        quantityMT = cityDetail.material_total_quantity;
      } else if (cityDetail.material_wise_uom === "Cubic Meter") {
        quantityMT = cityDetail.material_total_quantity * 1.6;
      } else if (cityDetail.material_wise_uom === "Bag") {
        quantityMT = cityDetail.material_total_quantity * 0.05;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Sand")
      ) {
        quantityMT =
          cityDetail.material_total_quantity * cityDetail.sand_conversion;
      } else if (
        cityDetail.material_wise_uom === "Cum." &&
        cityDetail.category_tree_name.includes("Aggregate")
      ) {
        quantityMT =
          cityDetail.material_total_quantity * cityDetail.aggregate_conversion;
      }

      // const baseRate =
      //   (cityDetail.final_bid_price_unit_rate || 0) +
      //   (cityDetail.final_bid_price_unit_rate_of_freight || 0);

      if (cityDetail.material_wise_uom === "MT") {
        rateMT = baseRate; // already per MT
      } else if (
        cityDetail.category_tree_name.includes("Sand") &&
        cityDetail.material_wise_uom === "Cum."
      ) {
        rateMT = baseRate / cityDetail.sand_conversion;
      } else if (
        cityDetail.category_tree_name.includes("Aggregate") &&
        cityDetail.material_wise_uom === "Cum."
      ) {
        rateMT = baseRate / cityDetail.aggregate_conversion;
      } else if (
        cityDetail.material_wise_uom === "Cubic Meter" ||
        cityDetail.material_wise_uom === "Cum."
      ) {
        rateMT = baseRate / 1.6; // per Cum → per MT
      } else if (cityDetail.material_wise_uom === "Bag") {
        rateMT = baseRate / 0.05; // per Bag → per MT
      }

      const weightedPrice = rateMT * quantityMT;

      // materialTotals[key].total_weighted_price += weightedPrice;
      // materialTotals[key].total_quantity_MT += quantityMT;
      // materialTotals[key].category_tree_name = cityDetail.category_tree_name;

      materialTotals[key].total_quantity_MT += quantityMT;
      materialTotals[key].total_weighted_price += rateMT * quantityMT;
      materialTotals[key].category_tree_name = cityDetail.category_tree_name;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const {
        total_weighted_price,
        total_quantity_MT,
        total_quantity_meter,
        category_tree_name,
      } = material;

      if (category_tree_name.includes("Earthing")) {
        const averagePriceMeter = total_quantity_meter
          ? total_weighted_price / total_quantity_meter
          : 0;

        const isCopper = material.material_type_name
          ?.toUpperCase()
          .includes("CU");

        const isGI = material.material_type_name?.toUpperCase().includes("GI");

        const sizeMatch =
          material.material_type_name.match(/(\d+)\s*x\s*(\d+)/i);

        const width = sizeMatch ? Number(sizeMatch[1]) : 0;
        const thickness = sizeMatch ? Number(sizeMatch[2]) : 0;

        let density = 0;
        if (isCopper) density = 8960;
        else if (isGI) density = 7850;

        const kgPerMeter =
          width && thickness && density
            ? (width * thickness * density) / 1_000_000
            : 0;

        const averagePriceKG =
          averagePriceMeter && kgPerMeter ? averagePriceMeter / kgPerMeter : 0;

        return {
          ...material,
          averagePriceMeter,
          averagePriceKG,
          kgPerMeter,
        };
      }

      const averagePriceMT = total_quantity_MT
        ? total_weighted_price / total_quantity_MT
        : 0;

      let averagePriceCum = 0;
      if (category_tree_name?.includes("Sand")) {
        averagePriceCum = averagePriceMT * (1 / (sandConversion || 1.6));
      } else if (category_tree_name?.includes("Aggregate")) {
        averagePriceCum = averagePriceMT * (1 / (aggregateConversion || 1.45));
      } else {
        averagePriceCum = averagePriceMT * (1 / 1.6);
      }

      const averagePriceKG = averagePriceMT / 1000;
      const averagePriceBag = averagePriceMT * 0.05;

      return {
        ...material,
        averagePriceMT,
        averagePriceCum,
        averagePriceKG: averagePriceMT / 1000,
        averagePriceBag: averagePriceMT * 0.05,
      };
    });

    setSummaryTableDataFinal(fattenData);
  }, [tableSummary]);

  const columns4 = [
    {
      title: "R0 - Initial BID (without GST)",
      children: [
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
          render: (text, record) =>
            record.uom !== "Cubic Meter" ? <span>{text}</span> : null,
        },

        // Average Price / MT (NOT Earthing)
        ...(!categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/MT",
                dataIndex: "averagePriceMT",
                key: "averagePriceMT",
                align: "right",
                render: (value) =>
                  initialBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / MT`,
              },
              {
                title: "Average Price/Bag",
                dataIndex: "averagePriceBag",
                key: "averagePriceBag",
                align: "right",
                render: (value) =>
                  initialBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Bag`,
              },
            ]
          : []),

        // Average Price / Cum (Sand / Aggregate only, NOT Earthing)
        ...((categoryTreeName.includes("Sand") ||
          categoryTreeName.includes("Aggregate")) &&
        !categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Cum.",
                dataIndex: "averagePriceCum",
                key: "averagePriceCum",
                align: "right",
                render: (value) =>
                  initialBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Cum`,
              },
            ]
          : []),

        // Average Price / Meter (Earthing only)
        ...(categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Meter",
                dataIndex: "averagePriceMeter",
                key: "averagePriceMeter",
                align: "right",
                render: (value) =>
                  initialBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Meter`,
              },
            ]
          : []),

        // KG & Bag (NOT Sand / Aggregate)
        ...(!(
          categoryTreeName.includes("Sand") ||
          categoryTreeName.includes("Aggregate")
        )
          ? [
              {
                title: "Average Price/KG",
                dataIndex: "averagePriceKG",
                key: "averagePriceKG",
                align: "right",
                render: (value) =>
                  initialBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / KG`,
              },
              // {
              //   title: "Average Price/Bag",
              //   dataIndex: "averagePriceBag",
              //   key: "averagePriceBag",
              //   align: "right",
              //   render: (value) =>
              //     initialBidDates && isNaN(value)
              //       ? "Not Quoted"
              //       : `₹ ${(value || 0).toFixed(2)} / Bag`,
              // },
            ]
          : []),
      ],
    },
  ];

  const columns4Revised = [
    {
      title: "R1 - Revised BID (without GST)",
      children: [
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
        },
        // Average Price / MT (NOT Earthing)
        ...(!categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/MT",
                dataIndex: "averagePriceMT",
                key: "averagePriceMT",
                align: "right",
                render: (averagePriceMT) => {
                  if (revisedBidDates && isNaN(averagePriceMT)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceMT
                      ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                      : `₹ 0`;
                  }
                },
              },
              {
                title: "Average Price/Bag",
                dataIndex: "averagePriceBag",
                key: "averagePriceBag",
                align: "right",
                render: (averagePriceBag) => {
                  if (revisedBidDates && isNaN(averagePriceBag)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceBag
                      ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
                      : `₹ 0`;
                  }
                },
              },
            ]
          : []),
        ...(categoryTreeName.includes("Sand") ||
        (categoryTreeName.includes("Aggregate") &&
          !categoryTreeName.includes("Earthing"))
          ? [
              {
                title: "Average Price/Cum.",
                dataIndex: "averagePriceCum",
                key: "averagePriceCum",
                align: "right",
                render: (averagePriceCum) => {
                  if (initialBidDates && isNaN(averagePriceCum)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceCum
                      ? `₹ ${averagePriceCum.toFixed(2)} / Cum`
                      : `₹ 0`;
                  }
                },
              },
            ]
          : []),
        ...(categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Meter",
                dataIndex: "averagePriceMeter",
                key: "averagePriceMeter",
                align: "right",
                render: (value) =>
                  revisedBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Meter`,
              },
            ]
          : []),
        ...(categoryTreeName.includes("Sand") ||
        categoryTreeName.includes("Aggregate")
          ? []
          : [
              {
                title: "Average Price/KG",
                dataIndex: "averagePriceKG",
                key: "averagePriceKG",
                align: "right",
                render: (averagePriceKG) => {
                  if (revisedBidDates && isNaN(averagePriceKG)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceKG
                      ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                      : `₹ 0`;
                  }
                },
              },
              // {
              //   title: "Average Price/Bag",
              //   dataIndex: "averagePriceBag",
              //   key: "averagePriceBag",
              //   align: "right",
              //   render: (averagePriceBag) => {
              //     if (revisedBidDates && isNaN(averagePriceBag)) {
              //       return "Not Quoted";
              //     } else {
              //       return averagePriceBag
              //         ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
              //         : `₹ 0`;
              //     }
              //   },
              // },
            ]),
      ],
    },
  ];

  const columns4Final = [
    {
      title: "R - Final BID (without GST)",
      children: [
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
        },
        ...(!categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/MT",
                dataIndex: "averagePriceMT",
                key: "averagePriceMT",
                align: "right",
                render: (averagePriceMT) => {
                  if (finalBidDates && isNaN(averagePriceMT)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceMT
                      ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                      : `₹ 0`;
                  }
                },
              },
              {
                title: "Average Price/Bag",
                dataIndex: "averagePriceBag",
                key: "averagePriceBag",
                align: "right",
                render: (averagePriceBag) => {
                  if (finalBidDates && isNaN(averagePriceBag)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceBag
                      ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
                      : `₹ 0`;
                  }
                },
              },
            ]
          : []),
        ...(categoryTreeName.includes("Sand") ||
        (categoryTreeName.includes("Aggregate") &&
          !categoryTreeName.includes("Earthing"))
          ? [
              {
                title: "Average Price/Cum.",
                dataIndex: "averagePriceCum",
                key: "averagePriceCum",
                align: "right",
                render: (averagePriceCum) => {
                  if (revisedBidDates && isNaN(averagePriceCum)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceCum
                      ? `₹ ${averagePriceCum.toFixed(2)} / Cum`
                      : `₹ 0`;
                  }
                },
              },
            ]
          : []),
        ...(categoryTreeName.includes("Earthing")
          ? [
              {
                title: "Average Price/Meter",
                dataIndex: "averagePriceMeter",
                key: "averagePriceMeter",
                align: "right",
                render: (value) =>
                  finalBidDates && isNaN(value)
                    ? "Not Quoted"
                    : `₹ ${(value || 0).toFixed(2)} / Meter`,
              },
            ]
          : []),
        ...(categoryTreeName.includes("Sand") ||
        categoryTreeName.includes("Aggregate")
          ? []
          : [
              {
                title: "Average Price/KG",
                dataIndex: "averagePriceKG",
                key: "averagePriceKG",
                align: "right",
                render: (averagePriceKG) => {
                  if (finalBidDates && isNaN(averagePriceKG)) {
                    return "Not Quoted";
                  } else {
                    return averagePriceKG
                      ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                      : `₹ 0`;
                  }
                },
              },
              // {
              //   title: "Average Price/Bag",
              //   dataIndex: "averagePriceBag",
              //   key: "averagePriceBag",
              //   align: "right",
              //   render: (averagePriceBag) => {
              //     if (finalBidDates && isNaN(averagePriceBag)) {
              //       return "Not Quoted";
              //     } else {
              //       return averagePriceBag
              //         ? `₹ ${averagePriceBag.toFixed(2)} / Bag`
              //         : `₹ 0`;
              //     }
              //   },
              // },
            ]),
      ],
    },
  ];

  useEffect(() => {
    const amountsMap = {};

    tableData.forEach((item) => {
      if (item.siteId && item.material_type) {
        const key = `${item.siteId}-${item.material_type}`;

        const totalAmountWithoutGstR0 =
          ((parseFloat(item.initial_bid_price_unit_rate) || 0) +
            (parseFloat(item.initial_bid_price_unit_rate_of_freight) || 0)) *
          (parseFloat(item.material_total_quantity) || 0);
        const gstAmountR0 =
          totalAmountWithoutGstR0 * ((parseFloat(item.gst_rate) || 0) / 100);
        const totalAmountWithGstR0 = totalAmountWithoutGstR0 + gstAmountR0;

        const totalAmountWithoutGstR1 =
          ((parseFloat(item.revised_bid_price_unit_rate) || 0) +
            (parseFloat(item.revised_bid_price_unit_rate_of_freight) || 0)) *
          (parseFloat(item.material_total_quantity) || 0);
        const gstAmountR1 =
          totalAmountWithoutGstR1 * ((parseFloat(item.gst_rate) || 0) / 100);
        const totalAmountWithGstR1 = totalAmountWithoutGstR1 + gstAmountR1;

        const totalAmountWithoutGstR =
          ((parseFloat(item.final_bid_price_unit_rate) || 0) +
            (parseFloat(item.final_bid_price_unit_rate_of_freight) || 0)) *
          (parseFloat(item.material_total_quantity) || 0);
        const gstAmountR =
          totalAmountWithoutGstR * ((parseFloat(item.gst_rate) || 0) / 100);
        const totalAmountWithGstR = totalAmountWithoutGstR + gstAmountR;

        if (!amountsMap[key]) {
          amountsMap[key] = {
            totalAmountWithGstR0: 0,
            totalAmountWithoutGstR0: 0,
            totalAmountWithGstR1: 0,
            totalAmountWithoutGstR1: 0,
            totalAmountWithGstR: 0,
            totalAmountWithoutGstR: 0,
          };
        }

        amountsMap[key].totalAmountWithGstR0 += totalAmountWithGstR0;
        amountsMap[key].totalAmountWithoutGstR0 += totalAmountWithoutGstR0;

        amountsMap[key].totalAmountWithGstR1 += totalAmountWithGstR1;
        amountsMap[key].totalAmountWithoutGstR1 += totalAmountWithoutGstR1;

        amountsMap[key].totalAmountWithGstR += totalAmountWithGstR;
        amountsMap[key].totalAmountWithoutGstR += totalAmountWithoutGstR;
      }
    });

    setAmountsBySiteAndMaterial(amountsMap);
  }, [tableData]);

  const handleCheckboxChange = (e) => {
    const value = e.target.checked;
    setIsFinalBid(value);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: value,
    }));

    if (initialBidDates) {
      setIsFinalWhen({
        ...isFinalWhen,
        isFinalR1: true,
      });
    } else if (!initialBidDates) {
      setIsFinalWhen({
        ...isFinalWhen,
        isFinalR0: true,
      });
    }
  };
  const resetUnitRateWithGst = (item) => {
    item.bid_rfq_site_details.forEach((site) => {
      site.bid_rfq_material_details.forEach((material) => {
        material.unit_rate_with_gst = null;
      });
    });
    return item;
  };

  const handleBidSubmission = () => {
    confirmAlert({
      title: "Confirm",
      message: isFinalBid ? (
        "Are you sure that you want to submit final no regret price as you will not able to modify the BID subsequently?"
      ) : revisedBidDates ? (
        `Are you sure you want to Submit BID ?`
      ) : (
        <>
          Are you sure you want to Submit BID ?<br />
          <span
            style={{
              color: "red",
              fontSize: "11px",
              fontWeight: "bold",
              padding: "20px",
            }}
          >
            Note: If the final BID is not submitted, the current BID will be
            considered as final.
          </span>
        </>
      ),
      buttons: [
        {
          label: "Yes",
          width: "90px",
          style: {
            backgroundColor: "#094e8f",
            color: "#fff",
            borderRadius: "4px",
            fontSize: "16px",
          },
          onClick: () => {
            if (currentStep === 0) {
              handleSubmit();
              resetGSTValues();
            } else if (currentStep === 1) {
              handleSubPatch();
              resetGSTValues();
            } else {
              handleSubPatch();
              resetGSTValues();
            }
          },
        },
        {
          label: "No",
          width: "90px",
          style: {
            backgroundColor: "#d9d9d9",
            color: "#000",
            borderRadius: "4px",
            fontSize: "16px",
          },
        },
      ],
    });
  };

  useEffect(() => {
    if (currentStep === 3) {
      navigate(`/rfq-vendor-request-for-quotation/history/1`);
    }
  }, [currentStep, CategoryId]);

  const isSubmitDisabled = tableData
    .filter((i) => i.siteName !== "Sub-Total" && i.siteName !== "City-Total")
    .every((item) =>
      finalBidDates
        ? item.final_bid_price_unit_rate === 0
        : revisedBidDates
        ? item.revised_bid_price_unit_rate === 0
        : item.initial_bid_price_unit_rate === 0
    );

  const handleSubmit = async () => {
    const currentDate = (() => {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    })();

    const updatedTableData = tableData.map((item) => {
      if (!item.isSubtotal && item.material_type_name) {
        return {
          ...item,
          initial_bid_price_date: currentDate,
          revised_bid_price_date: currentDate,
          final_bid_price_date: currentDate,
        };
      }
      return item;
    });

    setTableData(updatedTableData);

    const summaryDataMap = new Map();
    summaryTableData?.forEach((city) => {
      city?.sites?.forEach((site) => {
        summaryDataMap?.set(site.site_id, site);
      });
    });

    const uniqueEntries = new Map();

    const payload = {
      vendor: VendorId,
      is_final_bid_price: isFinalBid,
      bid_buying_pattern: buyingPatternPayload,
      bid_rfq_city_wise_detail: tableData.reduce((cityWiseDetails, entry) => {
        if (!entry.siteId || !entry.city_id) return cityWiseDetails;

        let cityDetail = cityWiseDetails.find(
          (city) => city.city_name === entry.city_id
        );
        if (!cityDetail) {
          cityDetail = {
            city_name: entry.city_id,
            bid_rfq_site_details: [],
          };
          cityWiseDetails.push(cityDetail);
        }

        let siteDetail = cityDetail.bid_rfq_site_details.find(
          (site) => site.site_id === entry.siteId
        );
        if (!siteDetail) {
          siteDetail = {
            site_id: entry.siteId,
            site_name: entry.site_name,

            rfq_vendor_detail: entry.rfq_vendor_detail,
            bid_rfq_material_details: [],
          };
          cityDetail.bid_rfq_site_details.push(siteDetail);
        }

        const key = `${entry.siteId}-${entry.material_type}`;
        const siteAmounts = amountsBySiteAndMaterial[key] || {};

        let materialDetail = siteDetail.bid_rfq_material_details.find(
          (material) =>
            material.rfq_material_detail.toString() ===
            entry.rfq_material_detail.toString()
        );

        if (!materialDetail) {
          siteDetail.bid_rfq_material_details.push({
            rfq_material_detail: entry.rfq_material_detail,
            material_type_name: entry.material_type_name,
            material_type: entry.material_type,
            material_total_quantity: entry.material_total_quantity,
            material_total_quantity_by_kg: entry.material_total_quantity_by_kg,
            gst_rate: entry.gst_rate,
            gst_rate_freight: entry.gst_rate_freight,
            id: entry.bid_rfq_id || null,
            material_wise_uom: entry.material_wise_uom || "MT",
            unit_of_measurement: entry.material_wise_uom_id || 1,
            initial_bid_price_unit_rate: entry.initial_bid_price_unit_rate,
            initial_bid_price_unit_rate_of_freight:
              entry.initial_bid_price_unit_rate_of_freight,
            revised_bid_price_unit_rate: entry.revised_bid_price_unit_rate,
            revised_bid_price_unit_rate_of_freight:
              entry.revised_bid_price_unit_rate_of_freight,
            final_bid_price_unit_rate: entry.final_bid_price_unit_rate,
            final_bid_price_unit_rate_of_freight:
              entry.final_bid_price_unit_rate_of_freight,

            initial_bid_amount_with_gst: siteAmounts.totalAmountWithGstR0 || 0,
            initial_bid_amount_without_gst:
              siteAmounts.totalAmountWithoutGstR0 || 0,
            revised_bid_amount_with_gst: siteAmounts.totalAmountWithGstR1 || 0,
            revised_bid_amount_without_gst:
              siteAmounts.totalAmountWithoutGstR1 || 0,
            final_bid_amount_with_gst: siteAmounts.totalAmountWithGstR || 0,
            final_bid_amount_without_gst:
              siteAmounts.totalAmountWithoutGstR || 0,

            unit_rate_with_gst: entry.unit_rate_with_gst || 0,
            is_inital_final_bid: isFinalWhen.isFinalR0,
            is_revised_final_bid: isFinalWhen.isFinalR1,
            is_final_final_bid: isFinalWhen.isFinalR,
            is_initial_bid: true,
          });
        }

        return cityWiseDetails;
      }, []),
    };

    try {
      setLoading(true);
      let response;
      response = await patchRequest(
        `bid-rfq/${vendorBidId}/create-bid-rfq/`,
        payload
      );

      if (response.data.success) {
        setLoading(false);
        navigate(`/rfq-vendor-request-for-quotation/history/1`);
        setCurrentStep(currentStep + 1);

        if (isFinalBid) {
          SuccessNotificationMsg(t("Final BID Submitted"));
        } else {
          if (currentStep === 0) {
            SuccessNotificationMsg(t("bidding_of_R0"));
          }
        }
        if (isFinalBid) {
          navigate(`/rfq-vendor-request-for-quotation/history/1`);
        }

        let cityTotals = {};
        let serialNumber = 0;
        let lastCityName = null;
        let lastSiteName = null;

        const fattenData =
          response.data.data.data.bid_rfq_city_wise_detail.flatMap(
            (cityDetail, cityIndex) => {
              const siteMap = {};

              cityDetail.bid_rfq_site_details.forEach((siteDetail) => {
                const siteId = siteDetail.site_id;

                if (!siteMap[siteId]) {
                  siteMap[siteId] = {
                    ...siteDetail,
                    bid_rfq_material_details: [],
                    showSiteName: true,
                    subtotal: {
                      initial_bid_price_unit_rate: 0,
                      initial_bid_price_unit_rate_of_freight: 0,
                      material_total_quantity: 0,
                      material_total_quantity_kg: 0,
                      gst_rate: 0,
                      unit_rate_with_gst: 0,
                    },
                  };
                }

                siteDetail.bid_rfq_material_details.forEach(
                  (materialDetail) => {
                    const materialType = materialDetail.material_type;
                    const rfqVendorDetail = siteDetail.rfq_vendor_detail;

                    const existingMaterial = siteMap[
                      siteId
                    ].bid_rfq_material_details.find(
                      (material) => material.material_type === materialType
                    );

                    if (existingMaterial) {
                      existingMaterial.material_total_quantity +=
                        materialDetail.material_total_quantity || 0;
                      existingMaterial.material_total_quantity_by_kg +=
                        materialDetail.material_total_quantity_by_kg || 0;
                      existingMaterial.gst_rate += materialDetail.gst_rate || 0;
                      existingMaterial.initial_bid_price_unit_rate +=
                        materialDetail.initial_bid_price_unit_rate || 0;
                      existingMaterial.initial_bid_price_unit_rate_of_freight +=
                        materialDetail.initial_bid_price_unit_rate_of_freight ||
                        0;

                      existingMaterial.rfq_vendor_detail = rfqVendorDetail;
                    } else {
                      siteMap[siteId].bid_rfq_material_details.push({
                        ...materialDetail,
                        rfq_vendor_detail: rfqVendorDetail,
                      });
                    }

                    siteMap[siteId].subtotal.initial_bid_price_unit_rate +=
                      materialDetail.initial_bid_price_unit_rate || 0;
                    siteMap[
                      siteId
                    ].subtotal.initial_bid_price_unit_rate_of_freight +=
                      materialDetail.initial_bid_price_unit_rate_of_freight ||
                      0;
                    siteMap[siteId].subtotal.material_total_quantity +=
                      materialDetail.material_total_quantity || 0;
                    siteMap[siteId].subtotal.material_total_quantity_kg +=
                      materialDetail.material_total_quantity_by_kg || 0;
                    siteMap[siteId].subtotal.gst_rate +=
                      materialDetail.gst_rate || 0;
                    siteMap[siteId].subtotal.unit_rate_with_gst +=
                      materialDetail.unit_rate_with_gst || 0;
                  }
                );
              });

              const siteRows = Object.values(siteMap).flatMap(
                (site, siteIndex) => {
                  const materialRows = site.bid_rfq_material_details.map(
                    (material) => {
                      const isCityChanged =
                        lastCityName !== cityDetail.city_name;
                      const isSiteChanged = lastSiteName !== site.site_name;

                      if (isCityChanged) {
                        serialNumber++;
                        lastCityName = cityDetail.city_name;
                      }

                      if (isSiteChanged) {
                        lastSiteName = site.site_name;
                      }

                      return {
                        sr_no: isCityChanged ? serialNumber : null,
                        city_id: cityDetail.city_name,
                        city_name: isCityChanged
                          ? cityDetail.city_name || null
                          : null,
                        site_name: isSiteChanged
                          ? site.site_name || null
                          : null,
                        siteId: site.site_id,
                        material_type_name: material.material_type_name || "",
                        material_wise_uom: material.material_wise_uom || "",
                        material_wise_uom_id: material.unit_of_measurement,
                        material_type: material.material_type || null,
                        material_total_quantity:
                          material.material_total_quantity || 0,
                        gst_rate: material.gst_rate || 0,
                        gst_rate_freight: material.gst_rate_freight || 0,
                        initial_bid_price_unit_rate:
                          material.initial_bid_price_unit_rate || 0,
                        initial_bid_price_unit_rate_of_freight:
                          material.initial_bid_price_unit_rate_of_freight || 0,
                        revised_bid_price_unit_rate:
                          material.revised_bid_price_unit_rate,
                        revised_bid_price_unit_rate_of_freight:
                          material.revised_bid_price_unit_rate_of_freight,
                        final_bid_price_unit_rate:
                          material.final_bid_price_unit_rate,
                        final_bid_price_unit_rate_of_freight:
                          material.final_bid_price_unit_rate_of_freight,
                        unit_rate_with_gst: material.unit_rate_with_gst,
                        rfq_vendor_detail: material.rfq_vendor_detail,
                        initial_bid_price_date: material.initial_bid_price_date,
                        revised_bid_price_date: material.revised_bid_price_date,
                        final_bid_price_date: material.final_bid_price_date,
                        rfq_material_detail: material.rfq_material_detail,
                        bid_rfq_id: material.bid_rfq_id,
                      };
                    }
                  );
                  const totalInitialBidPrice = materialRows.reduce(
                    (acc, row) => acc + (row.initial_bid_price_unit_rate || 0),
                    0
                  );
                  const totalRevisedUniBidPrice = materialRows.reduce(
                    (acc, row) => acc + (row.revised_bid_price_unit_rate || 0),
                    0
                  );
                  materialRows.push({
                    key: `${cityIndex}-${siteIndex}-SubTotal`,
                    siteName: "Sub-Total",
                    siteId: site.site_id,
                    qty: site.subtotal.material_total_quantity,
                    qty_kg: site.subtotal.material_total_quantity_kg,
                    total_initial_bid_price_unit_rate: totalInitialBidPrice,
                    total_revised_bid_price_unit_rate: totalRevisedUniBidPrice,
                    total_unit_rate_with_gst: 0,
                  });
                  return materialRows;
                }
              );

              const totalInitialBidPrice = siteRows.reduce(
                (acc, row) =>
                  acc + (row.total_initial_bid_price_unit_rate || 0),
                0
              );
              const totalRevisedBidPrice = siteRows.reduce(
                (acc, row) =>
                  acc + (row.total_revised_bid_price_unit_rate || 0),
                0
              );

              siteRows.push({
                key: `city-${cityIndex}-Total`,
                siteName: "City-Total",
                qty: cityTotals[cityDetail.city_id]
                  .total_material_total_quantity,
                qty_kg:
                  cityTotals[cityDetail.city_id]
                    .total_material_total_quantity_kg,
                total_initial_bid_price_unit_rate: totalInitialBidPrice,
                total_initial_bid_price_unit_rate_of_freight:
                  cityTotals[cityDetail.city_id]
                    .total_initial_bid_price_unit_rate_of_freight,
                total_revised_bid_price_unit_rate: totalRevisedBidPrice,
                total_revised_bid_price_unit_rate_of_freight:
                  cityTotals[cityDetail.city_id]
                    .total_revised_bid_price_unit_rate_of_freight,
                total_unit_rate_with_gst: 0,
              });

              return siteRows;
            }
          );
        setTableData(fattenData);
        setBuyingPatternPayload(response.data.data.bid_buying_pattern);

        if (trackingOfStages === 2) {
          navigate(`/rfq-vendor-request-for-quotation/history/1`);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSubPatch = async () => {
    const currentDate = (() => {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    })();

    const updatedTableData = tableData.map((item) => {
      if (!item.isSubtotal && item.material_type_name) {
        return {
          ...item,
          initial_bid_price_date: currentDate,
          revised_bid_price_date: currentDate,
          final_bid_price_date: currentDate,
        };
      }
      return item;
    });

    setTableData(updatedTableData);

    const summaryDataMap = new Map();
    summaryTableData?.forEach((city) => {
      city?.sites?.forEach((site) => {
        summaryDataMap?.set(site.site_id, site);
      });
    });

    const payload = {
      vendor: VendorId,

      is_final_bid_price: isFinalBid,
      bid_buying_pattern: buyingPatternPayload,
      bid_rfq_city_wise_detail: tableData.reduce((cityWiseDetails, entry) => {
        if (!entry.siteId || !entry.city_id) return cityWiseDetails;

        let cityDetail = cityWiseDetails.find(
          (city) => city.city_name === entry.city_id
        );
        if (!cityDetail) {
          cityDetail = {
            city_name: entry.city_id,
            bid_rfq_site_details: [],
          };
          cityWiseDetails.push(cityDetail);
        }

        let siteDetail = cityDetail.bid_rfq_site_details.find(
          (site) => site.site_id === entry.siteId
        );
        if (!siteDetail) {
          siteDetail = {
            site_id: entry.siteId,
            site_name: entry.site_name,
            site_wise_uom: entry.material_wise_uom || "MT",
            rfq_vendor_detail: entry.rfq_vendor_detail,
            bid_rfq_material_details: [],
          };
          cityDetail.bid_rfq_site_details.push(siteDetail);
        }

        const key = `${entry.siteId}-${entry.material_type}`;
        const siteAmounts = amountsBySiteAndMaterial[key] || {};

        let materialDetail = siteDetail.bid_rfq_material_details.find(
          (material) =>
            material.rfq_material_detail.toString() ===
            entry.rfq_material_detail.toString()
        );

        if (!materialDetail) {
          siteDetail.bid_rfq_material_details.push({
            rfq_material_detail: entry.rfq_material_detail,
            material_type_name: entry.material_type_name,
            material_type: entry.material_type,
            material_total_quantity: entry.material_total_quantity,
            material_wise_uom: entry.material_wise_uom || "MT",
            unit_of_measurement: entry.material_wise_uom_id || 1,
            gst_rate: entry.gst_rate,
            gst_rate_freight: entry.gst_rate_freight,
            id: entry.bid_rfq_id || null,
            initial_bid_price_unit_rate: entry.initial_bid_price_unit_rate,
            initial_bid_price_unit_rate_of_freight:
              entry.initial_bid_price_unit_rate_of_freight,
            revised_bid_price_unit_rate: entry.revised_bid_price_unit_rate,
            revised_bid_price_unit_rate_of_freight:
              entry.revised_bid_price_unit_rate_of_freight,
            final_bid_price_unit_rate: entry.final_bid_price_unit_rate,
            final_bid_price_unit_rate_of_freight:
              entry.final_bid_price_unit_rate_of_freight,

            initial_bid_amount_with_gst: siteAmounts.totalAmountWithGstR0 || 0,
            initial_bid_amount_without_gst:
              siteAmounts.totalAmountWithoutGstR0 || 0,
            revised_bid_amount_with_gst: siteAmounts.totalAmountWithGstR1 || 0,
            revised_bid_amount_without_gst:
              siteAmounts.totalAmountWithoutGstR1 || 0,
            final_bid_amount_with_gst: siteAmounts.totalAmountWithGstR || 0,
            final_bid_amount_without_gst:
              siteAmounts.totalAmountWithoutGstR || 0,

            unit_rate_with_gst: entry.unit_rate_with_gst || 0,
            revised_unit_rate_with_gst: entry.unit_rate_with_gst_revised || 0,
            final_unit_rate_with_gst: entry.unit_rate_with_gst_final || 0,

            is_inital_final_bid: isFinalWhen.isFinalR0,
            is_revised_final_bid: isFinalWhen.isFinalR1,
            is_final_final_bid: isFinalWhen.isFinalR,

            is_initial_bid: entry.is_initial_bid,
            is_revised_bid:
              entry.is_initial_bid === true ? true : entry.is_revised_bid,
            is_final_bid:
              entry.is_revised_bid === true ? true : entry.is_final_bid,
          });
        }

        return cityWiseDetails;
      }, []),
    };

    try {
      setLoading(true);
      let response;
      response = await patchRequest(`bid-rfq/${vendorBidId}/`, payload);
      if (response.data.success) {
        setLoading(false);

        setCurrentStep(currentStep + 1);
        setBuyingPatternPayload(response.data.data.bid_buying_pattern);
        if (currentStep === 0) {
          SuccessNotificationMsg(t("bidding_of_R0"));
        } else if (currentStep === 1) {
          navigate(`/rfq-vendor-request-for-quotation/history/1`);

          if (isFinalBid) {
            SuccessNotificationMsg(t("Final BID Submitted"));
          } else {
            SuccessNotificationMsg(t("bidding_of_R1"));
          }
        } else {
          navigate(`/rfq-vendor-request-for-quotation/history/1`);
          if (isFinalBid) {
            SuccessNotificationMsg(t("Final BID Submitted"));
          } else {
            SuccessNotificationMsg(t("bidding_of_R"));
          }
        }

        let serialNumber = 0;
        let lastCityName = null;
        let lastSiteName = null;

        const fattenData =
          response.data.data.data.bid_rfq_city_wise_detail.flatMap(
            (cityDetail, cityIndex) => {
              const siteMap = {};

              cityDetail.bid_rfq_site_details.forEach((siteDetail) => {
                const siteId = siteDetail.site_id;

                if (!siteMap[siteId]) {
                  siteMap[siteId] = {
                    ...siteDetail,
                    bid_rfq_material_details: [],
                    showSiteName: true,
                    subtotal: {
                      initial_bid_price_unit_rate: 0,
                      initial_bid_price_unit_rate_of_freight: 0,
                      material_total_quantity: 0,
                      gst_rate: 0,
                      unit_rate_with_gst: 0,
                    },
                  };
                }

                siteDetail.bid_rfq_material_details.forEach(
                  (materialDetail) => {
                    const materialType = materialDetail.material_type;
                    const rfqVendorDetail = siteDetail.rfq_vendor_detail;

                    const existingMaterial = siteMap[
                      siteId
                    ].bid_rfq_material_details.find(
                      (material) => material.material_type === materialType
                    );

                    if (existingMaterial) {
                      existingMaterial.material_total_quantity +=
                        materialDetail.material_total_quantity || 0;
                      existingMaterial.gst_rate += materialDetail.gst_rate || 0;
                      existingMaterial.initial_bid_price_unit_rate +=
                        materialDetail.initial_bid_price_unit_rate || 0;
                      existingMaterial.initial_bid_price_unit_rate_of_freight +=
                        materialDetail.initial_bid_price_unit_rate_of_freight ||
                        0;
                      existingMaterial.unit_rate_with_gst +=
                        materialDetail.unit_rate_with_gst || 0;
                      existingMaterial.rfq_vendor_detail = rfqVendorDetail;
                    } else {
                      siteMap[siteId].bid_rfq_material_details.push({
                        ...materialDetail,
                        rfq_vendor_detail: rfqVendorDetail,
                      });
                    }

                    siteMap[siteId].subtotal.initial_bid_price_unit_rate +=
                      materialDetail.initial_bid_price_unit_rate || 0;
                    siteMap[
                      siteId
                    ].subtotal.initial_bid_price_unit_rate_of_freight +=
                      materialDetail.initial_bid_price_unit_rate_of_freight ||
                      0;
                    siteMap[siteId].subtotal.material_total_quantity +=
                      materialDetail.material_total_quantity || 0;
                    siteMap[siteId].subtotal.gst_rate +=
                      materialDetail.gst_rate || 0;
                    siteMap[siteId].subtotal.unit_rate_with_gst +=
                      materialDetail.unit_rate_with_gst || 0;
                  }
                );
              });

              return Object.values(siteMap).flatMap((site, siteIndex) => {
                const materialRows = site.bid_rfq_material_details.map(
                  (material) => {
                    const isCityChanged = lastCityName !== cityDetail.city_name;
                    const isSiteChanged = lastSiteName !== site.site_name;

                    if (isCityChanged) {
                      serialNumber++;
                      lastCityName = cityDetail.city_name;
                    }

                    if (isSiteChanged) {
                      lastSiteName = site.site_name;
                    }

                    return {
                      sr_no: isCityChanged ? serialNumber : null,
                      city_id: cityDetail.city_name,
                      city_name: isCityChanged
                        ? cityDetail.city_name || null
                        : null,
                      site_name: isSiteChanged ? site.site_name || null : null,
                      siteId: site.site_id,
                      material_type_name: material.material_type_name || "",
                      material_wise_uom: material.material_wise_uom || "",
                      material_wise_uom_id: material.unit_of_measurement,
                      material_type: material.material_type || null,
                      material_total_quantity:
                        material.material_total_quantity || 0,
                      gst_rate: material.gst_rate || 0,
                      initial_bid_price_unit_rate:
                        material.initial_bid_price_unit_rate || 0,
                      initial_bid_price_unit_rate_of_freight:
                        material.initial_bid_price_unit_rate_of_freight || 0,
                      revised_bid_price_unit_rate:
                        material.revised_bid_price_unit_rate,
                      revised_bid_price_unit_rate_of_freight:
                        material.revised_bid_price_unit_rate_of_freight,
                      final_bid_price_unit_rate:
                        material.final_bid_price_unit_rate,
                      final_bid_price_unit_rate_of_freight:
                        material.final_bid_price_unit_rate_of_freight,
                      unit_rate_with_gst: 0,
                      rfq_vendor_detail: material.rfq_vendor_detail,
                      initial_bid_price_date: material.initial_bid_price_date,
                      revised_bid_price_date: material.revised_bid_price_date,
                      final_bid_price_date: material.final_bid_price_date,
                      rfq_material_detail: material.rfq_material_detail,
                      bid_rfq_id: material.bid_rfq_id,
                    };
                  }
                );
                const totalInitialBidPrice = materialRows.reduce(
                  (acc, row) => acc + (row.initial_bid_price_unit_rate || 0),
                  0
                );
                const totalRevisedBidPrice = materialRows.reduce(
                  (acc, row) => acc + (row.revised_bid_price_unit_rate || 0),
                  0
                );
                const totalFinalBidPrice = materialRows.reduce(
                  (acc, row) => acc + (row.final_bid_price_unit_rate || 0),
                  0
                );

                materialRows.push({
                  key: `${cityIndex}-${siteIndex}-SubTotal`,
                  siteName: "Sub-Total",
                  siteId: site.site_id,
                  qty: site.subtotal.material_total_quantity,
                  qty_kg: site.subtotal.material_total_quantity_kg,
                  total_initial_bid_price_unit_rate: totalInitialBidPrice,
                  total_revised_bid_price_unit_rate: totalRevisedBidPrice,
                  total_final_bid_price_unit_rate: totalFinalBidPrice,
                  total_unit_rate_with_gst: 0,
                });

                return materialRows;
              });
            }
          );

        setTableData(fattenData);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const transformedData = {
    companyName: rfqDetails.company,
    rfqnumber: rfqDetails.rfq_number,
    rfqcurrency: rfqDetails.currency_name,
    rfqpricebasis: rfqDetails.price_basis,
    rfqfreight: rfqDetails.freight,
    rfqunloading: rfqDetails.unloading,
    rfqtransportInsurance: rfqDetails.transport_insurance,
    rfqduedate: rfqDetails.rfq_due_date,
    rfqopendeliverydate: rfqDetails.delivery_date,
    rfqamountcap: rfqDetails.amount_cap || "N/A",
    rfqtimelinecap: rfqDetails.open_order ? "Timeline Cap Data" : "N/A",
    rfqdeliverystartdate: rfqDetails.delivery_start_date || "N/A",
    rfqdeliveryenddate: rfqDetails.delivery_end_date || "N/A",
    open_order: rfqDetails.open_order,
  };

  const columns1 = [
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "RFQ Number",
      dataIndex: "rfqnumber",
      key: "rfqnumber",
    },
    {
      title: "Currency",
      dataIndex: "rfqcurrency",
      key: "rfqcurrency",
    },
    {
      title: "Price Basis",
      dataIndex: "rfqpricebasis",
      key: "rfqpricebasis",
    },
    {
      title: "Freight",
      dataIndex: "rfqfreight",
      key: "rfqfreight",
    },
    {
      title: "Transport Insurance",
      dataIndex: "rfqtransportInsurance",
      key: "rfqtransportInsurance",
    },
    {
      title: "Unloading",
      dataIndex: "rfqunloading",
      key: "rfqunloading",
    },

    {
      title: "RFQ Due Date",
      dataIndex: "rfqduedate",
      key: "rfqduedate",
    },
    !rfqData.open_order && {
      title: "Delivery Date",
      dataIndex: "rfqopendeliverydate",
      key: "rfqopendeliverydate",
      render: (text, record) =>
        record.open_order ? "N/A" : record.rfqopendeliverydate,
    },
    rfqData.open_order && {
      title: "Amount Cap",
      dataIndex: "rfqamountcap",
      key: "rfqamountcap",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery Start Date",
      dataIndex: "rfqdeliverystartdate",
      key: "rfqdeliverystartdate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery End Date",
      dataIndex: "rfqdeliveryenddate",
      key: "rfqdeliveryenddate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
  ].filter(Boolean);

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename" style={{ whiteSpace: "nowrap" }}>
            <h3>BID RFQ - Vendor</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/rfq-vendor-request-for-quotation/history/1">
                  {t("RFQ History - Vendor")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>BID RFQ - Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <div className="dayfilter" style={{ color: "#094E8F" }}>
              <strong>Winning Ratio:</strong>
              <div
                className="rfq-number new"
                style={{ margin: "0", padding: "0" }}
              >
                {winningArray.map((item) => (
                  <Tooltip
                    key={item.key}
                    color="#094E8F"
                    placement="top"
                    title={`${item.value}%`}
                  >
                    <span>{item.key}</span>
                  </Tooltip>
                ))}
              </div>
            </div>
            <div className="dayfilter" style={{ color: "#094E8F" }}>
              <strong>Last 5 BID Result :</strong>
              <div
                className="rfq-number new"
                style={{ margin: "0", padding: "0" }}
              >
                {lastFiveBid?.map((bid, index) => {
                  let res = "";

                  if (bid === "Loose") {
                    res = "L";
                  } else if (bid === "N/A") {
                    res = "N/A";
                  } else {
                    res = "W";
                  }

                  if (index === 0) {
                    return (
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={"Latest"}
                        key={index}
                      >
                        <span>{res || ""}</span>
                      </Tooltip>
                    );
                  } else if (lastFiveBid.length - 1 === index) {
                    return (
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={"Earliest"}
                        key={index}
                      >
                        <span>{res || ""}</span>
                      </Tooltip>
                    );
                  } else {
                    return <span key={index}>{res || ""}</span>;
                  }
                })}
              </div>
            </div>
            <ButtonField
              type="primary"
              className="CancelGradiantBtn"
              htmlType="button"
              label={t("Back")}
              onClick={() =>
                navigate("/rfq-vendor-request-for-quotation/history/1")
              }
            />
          </div>
        </div>
      </div>
      <div className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec ">
            <div className="PR-body" style={{ padding: "0" }}>
              <div
                style={{
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#fff",
                }}
              >
                <Collapse
                  defaultActiveKey={[0]}
                  key={0}
                  className="custom-collapse-table"
                >
                  <Panel header={"RFQ Details"} key={0}>
                    <div style={{ marginTop: "10px" }}>
                      <Table
                        className="custom-head"
                        columns={columns1}
                        dataSource={[transformedData]}
                        pagination={false}
                        // sticky
                      />
                    </div>
                  </Panel>
                </Collapse>
              </div>

              <div>
                <Form autoComplete="off" ref={formRef}>
                  <Spin spinning={apiLoading}>
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      pagination={false}
                      bordered
                      scroll={{
                        x: 1000,
                      }}
                      sticky
                    />
                  </Spin>

                  <Row gutter={16} className="footerTablesContainer">
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable3"
                      style={{ paddingTop: "16px" }}
                    >
                      {currentStep >= 2 && (
                        <div style={{ maxWidth: "600px", overflowX: "auto" }}>
                          <Table
                            columns={columns4Final}
                            dataSource={summaryTableDataFinal}
                            pagination={false}
                            bordered
                            scroll={{
                              x: 500,
                            }}
                          />
                        </div>
                      )}
                      {currentStep >= 1 && !hideR1 && (
                        <div style={{ maxWidth: "600px", overflowX: "auto" }}>
                          <Table
                            columns={columns4Revised}
                            dataSource={summaryTableDataRevised}
                            pagination={false}
                            bordered
                            scroll={{
                              x: 500,
                            }}
                          />
                        </div>
                      )}
                      {!hideR0 && (
                        <div style={{ maxWidth: "600px", overflowX: "auto" }}>
                          <Table
                            columns={columns4}
                            dataSource={summaryTableData2}
                            pagination={false}
                            bordered
                            scroll={{
                              x: 400,
                            }}
                          />
                        </div>
                      )}
                    </Col>
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable4"
                      style={{
                        paddingTop: "16px",
                        maxWidth: "900px",
                        overflowX: "auto",
                      }}
                    >
                      <Table
                        columns={columns3}
                        dataSource={summaryTableData}
                        pagination={false}
                        bordered
                        scroll={{
                          x: "auto",
                        }}
                      />
                    </Col>
                  </Row>

                  <div className="FormFooter">
                    {currentStep !== 2 && (
                      <Checkbox
                        checked={isFinalBid}
                        onChange={(e) => handleCheckboxChange(e)}
                      >
                        <span className="finalBid">
                          Is This Your Final Bid Price?
                        </span>
                      </Checkbox>
                    )}
                    {currentStep >= 1 && (
                      <>
                        <Checkbox
                          checked={hideR0}
                          onChange={handleHideR0Change}
                        >
                          Hide Initial BID Price - R0
                        </Checkbox>
                      </>
                    )}
                    {currentStep >= 2 && (
                      <>
                        <Checkbox
                          checked={hideR1}
                          onChange={handleHideR1Change}
                        >
                          Hide BID Price - R1
                        </Checkbox>
                      </>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </section>
        </div>
        <div
          className="FormFooter bidftr"
          style={{ padding: "16px  ", margin: "0" }}
        >
          <ButtonField
            type="primary"
            className="CancelGradiantBtn"
            htmlType="button"
            label={t("Back")}
            onClick={() =>
              navigate("/rfq-vendor-request-for-quotation/history/1")
            }
          />
          <ButtonField
            type="primary"
            className="SaveGradiantBtn"
            htmlType="button"
            label="Submit BID"
            onClick={handleBidSubmission}
            loading={loading}
            disabled={isSubmitDisabled}
          />
        </div>
      </div>
    </>
  );
};

export default VendorNewBisRFQCityWise;
